import { DatePipe } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { GridComponent, PageService, SortService, SortSettingsModel } from '@syncfusion/ej2-angular-grids';
import { firstValueFrom, from, lastValueFrom, Observable, of, Subscription, take } from 'rxjs';
import { LayoutService } from 'src/app/services/layout.service';
import { MarketInfoService } from 'src/app/services/marketInfo.service';
import { OperationRentalService } from 'src/app/services/Rentals.service';
import { VendorService } from 'src/app/services/Vendor.service';
import { customCurrencyPipe } from 'src/app/Shared/customCurrency.pipe';
import { HourglassSpinnerComponent } from 'src/app/Shared/loader/hourglass-spinner/hourglass-spinner.component';
import { ANGULAR_MODULES, SYNCFUSION_MODULES } from 'src/app/Shared/shared-imports';
import Swal from 'sweetalert2';
import { OpsRentalLayoutComponent } from '../ops-rental-layout/ops-rental-layout.component';
import { RentalPayByboothComponent } from 'src/app/Shared/rental-pay-bybooth/rental-pay-bybooth.component';
import { ToastrService } from 'ngx-toastr';
import { LoaderComponent } from 'src/app/Shared/loader/loader.component';
import { WordReplacePipe } from 'src/app/Shared/word-replace.pipe';
import { SharedHTMLSettingsDataService } from 'src/app/Shared/sharedHTMLSettingsData.service';
import printJS from 'print-js';
import { GeneralService } from 'src/app/services/general.service';
import { RentalReceiptIDs } from 'src/app/Shared/enum'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PrinterSettingsService } from 'src/app/services/printer-settings.service';
import { Router } from '@angular/router';
import { ASLicenseSettings } from 'src/app/Shared/model/GeneralModel';
declare var $: any;
declare var bootstrap: any;
interface DateString {
  startDate: string;
}

@Component({
  selector: 'app-ops-vendor-monthly-rental',
  standalone: true,
  imports: [SYNCFUSION_MODULES, ANGULAR_MODULES, HourglassSpinnerComponent, OpsRentalLayoutComponent, RentalPayByboothComponent,
    LoaderComponent, WordReplacePipe],
  providers: [SortService, PageService],
  templateUrl: './ops-vendor-monthly-rental.html',
  styleUrl: './ops-vendor-monthly-rental.scss'
})
export class OpsVendorMonthlyRental {
  public loaderIcon: Promise<boolean>;
  public loadHourGlassLoader: Promise<boolean>;
  @Output() hideTopHeaders = new EventEmitter<any>();
  @Input() defaultRentalNotes;
  @Input() vendorIsInactive: boolean = false;
  boothsForOtherCharge = [];
  rentalForm: FormGroup;
  layoutParts;
  selectedMonthlyBoothData;
  selectedBoothsForRental = [];
  selectedOtherCharges = [];
  monthlyMarketDays;
  allAvailableBooths;
  displayLayout = false;
  MonthlyLayoutData;
  marketDaysEnabled;
  otherRentalCharges = [];
  otherItemList = [];
  isMonthlyboothSelected = false;
  warnExcessPayment = false;
  warnZeroPayment = false;
  displaySalesTax = false;
  displayCityTax = false;
  displayDefaultPart;
  defaultPartId;
  payByBooth = false
  PromptRenewOther = false;
  @Input() selectedEndDates;
  @Output() isFormDirty = new EventEmitter<any>();
  extendRentalRecord;
  BoothNumber;
  rentEndPeriodIndex
  rentalModel;
  Dues = [];
  isSwalOpen = false;
  printThermalReceipt = false;
  thermalReceiptCopies = 0;
  @ViewChild('modalAddNewMonthlyBooths', { static: false }) modalAddNewMonthlyBooths: ElementRef;
  uniqueSessionId = "";
  laserThermalReceipt: boolean = false;

  constructor(
    private operationRentalService: OperationRentalService,
    private layoutService: LayoutService,
    private formbuilder: FormBuilder,
    private marketInfoService: MarketInfoService,
    private datePipe: DatePipe,
    private vendorService: VendorService,
    private toastr: ToastrService,
    private sharedHTMLSettings: SharedHTMLSettingsDataService,
    private customCurrency: customCurrencyPipe,
    private sanitizer: DomSanitizer,
    private generalService: GeneralService,
    private printerService: PrinterSettingsService,
    private router: Router) {
    this.rentalForm = this.formbuilder.group({
      ReceiptAndContractSetting: this.formbuilder.group({
        displayReceipt: [false],
        printReceipt: [false],
        emailReceipt: [false],
        displayContract: [false],
        printContract: [false],
        emailContract: [false]
      }),
      vendorBalances: this.formbuilder.group({
        vendorPriorBalance: this.customCurrency.transform('0.00'),
        totalRentalCharge: [this.customCurrency.transform('0.00')],
        totalOtherRentalCharge: [this.customCurrency.transform('0.00')],
        totalSalesTax: [this.customCurrency.transform('0.00')],
        totalSecondLeveltax: [this.customCurrency.transform('0.00')],
        totalCharge: [this.customCurrency.transform('0.00')],
        totalDiscountCharge: [this.customCurrency.transform('0.00')]
      }),
      boothSearchScreen: this.formbuilder.group({
        boothParts: [''],
        rentalStartMonth: [''],
        rentalEndMonth: [''],
        marketDaysSunday: [{ value: false, disabled: true }],
        marketDaysMonday: [{ value: false, disabled: true }],
        marketDaysTuesday: [{ value: false, disabled: true }],
        marketDaysWednesday: [{ value: false, disabled: true }],
        marketDaysThursday: [{ value: false, disabled: true }],
        marketDaysFriday: [{ value: false, disabled: true }],
        marketDaysSaturday: [{ value: false, disabled: true }],
        rentalStartDates1: [''],
        srcBoothNumber: ['']
      }),
      RentalExtensionForm: this.formbuilder.group({
        rentalEndMonth: [''],
        marketDaysSunday: [{ value: false, disabled: true }],
        marketDaysMonday: [{ value: false, disabled: true }],
        marketDaysTuesday: [{ value: false, disabled: true }],
        marketDaysWednesday: [{ value: false, disabled: true }],
        marketDaysThursday: [{ value: false, disabled: true }],
        marketDaysFriday: [{ value: false, disabled: true }],
        marketDaysSaturday: [{ value: false, disabled: true }]
      }),
      otherItemsScreen: this.formbuilder.group({
        otherChargeMarketMonth: [''],
        otherItemSearchText: ['']
      })
    });
  }

  @HostListener('document:keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      const modal = this.modalAddNewMonthlyBooths.nativeElement;
      if (modal.classList.contains('show')) {
        event.preventDefault();

        if (this.isSwalOpen) {
          Swal.close();
          this.isSwalOpen = false;
        } else {
          //  wait for form control value to update
          setTimeout(() => {
            this.loadAvailableBooths();
          });
        }
      }
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): void {
    var temp = {
      TempRecordNo: this.tempRecordNo.toString(),
      BoothNo: ""
    }
    this.subscriptions.push(this.operationRentalService.deleteFromTemp(temp).subscribe((res: any) => {
    }));
  }

  rentalStartDates;
  parts = [];
  selectedOtherItems = [];
  allrentedOtherItems = [];
  displayLayoutPopup = false;
  selectedMonthlyBooths = [];
  totalRentalCharge = 0.00;
  totalOtherRentalCharge = 0.00;
  totalSalesTax = 0.00;
  totalSecondLeveltax = 0.00
  totalCharge = 0.00;
  disableSave = true;
  @ViewChild('gridMonthlyRental', { static: false }) public gridMonthlyRental: GridComponent;
  @ViewChild('gridOtherRental', { static: false }) public gridOtherRental: GridComponent;
  public subscriptions: Subscription[] = [];
  tempRecordNo;
  @Input() vendorId;
  selectedMarketDays = [];
  overrideRent;
  overrideOtherChargesRent;
  extendingBooth = false;
  renewAllBoothsFromGrid = false;
  displayOtherChargeByBooth = false;
  displayOtherChargeSalesTax = false;
  displayOtherChargeCityTax = false;
  masterRentChargeforResOtherItems = false;
  secondTaxName = "";
  RentalTaxPercentage = 0;
  priorBalance = 0;
  OtherRentalTaxPercentage = 0;
  RentalSecondTaxPercentage = 0;
  OtherRentalSecondTaxPercentage = 0;
  vendorProducts = [];
  defaultProduct;
  sortOptions: SortSettingsModel = {
    columns: [{ field: 'RentalStartDate', direction: 'Ascending' }, { field: 'BoothNumber', direction: 'Ascending' }]
  };
  sortOtherItemsOptions: SortSettingsModel = {
    columns: [{ field: 'OtherItem', direction: 'Ascending' }, { field: 'BoothNo', direction: 'Ascending' }]
  };

  receiptUrl: SafeResourceUrl | null = null;
  contractUrl: SafeResourceUrl | null = null;
  loading = false
  @Input() UserPermission;
  @Input() dayendOrOpenCashNotSaved;
  @Input() terminalNoSet;
  noLayout = false;

  ngOnInit(): void {
    this.generateTempRecordNumber();
    this.getASCloudLicenseSettings();
    this.getParts();
    this.getOtherRentalItems();
    this.getVendorProducts();
    this.getVendorBalances();
    this.getMarketDaysSettings();
    this.getMonthlyMarkets();
    this.getRentalPaymentSettings();
    this.getRentalPrinterSettings();
    this.getPOSPrinterSettings();
    this.overrideRent = this.UserPermission?.UserRoles?.OverrideRentalCharges;
    this.overrideOtherChargesRent = this.UserPermission?.UserRoles?.OverrideOtherCharges;;
    const tabId = sessionStorage.getItem('tabId');
    const sessionKey = `UniqueSessionId-${tabId}`;
    this.uniqueSessionId = localStorage.getItem(sessionKey);
  }

  getASCloudLicenseSettings(): void {
    const licenseSettings = this.generalService.ASLicenseSettings;
    if (licenseSettings !== null) {
      this.noLayout = licenseSettings.NoLayout ?? false;
      return;
    }

    this.generalService.getASCloudLicenseSettings().pipe(take(1)).subscribe({
      next: (res: ASLicenseSettings) => {
        this.generalService.ASLicenseSettings = res;
        this.noLayout = res.NoLayout ?? false;
      },
      error: () => {
        this.noLayout = false;
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedEndDates && !changes.selectedEndDates.firstChange) {
      this.handleEndDateChange();
    }
  }

  generateTempRecordNumber() {
    this.subscriptions.push(this.operationRentalService.generateTempRecordNumber().subscribe((response) => {
      if (response) {
        this.tempRecordNo = response;
      }
    }));
  }

  getRentalPrinterSettings() {
    this.loaderIcon = Promise.resolve(true);
    this.subscriptions.push(this.printerService.getRentalPrinterSettings().subscribe((res: any) => {
      if (res) {
        this.rentalForm.controls['ReceiptAndContractSetting'].patchValue
          ({
            displayReceipt: res.ReceiptDefaultChecked,
            printReceipt: res.PrintReceipt,
            emailReceipt: res.EmailReceipt,
            displayContract: res.ContractDefaultChecked,
            printContract: res.PrintContract,
            emailContract: res.EmailContract
          })
        this.printThermalReceipt = res.MonthlyThermal;
        this.thermalReceiptCopies = res.MonthlyCopies;
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    }));
  }

  getPOSPrinterSettings(): void {
    this.subscriptions.push(this.printerService.getPOSPrinterSettings()
      .subscribe(res => {
        this.laserThermalReceipt = res.ThermalFormatReceipt;
      }));
  }

  getParts() {
    this.loaderIcon = Promise.resolve(true);
    this.subscriptions.push(this.layoutService.getParts().subscribe((res: any) => {
      if (res) {
        this.parts = res;
        this.loaderIcon = Promise.resolve(false);
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    }));
  }

  openModalById(modalId) {
    document.querySelectorAll('.modal-backdrop').forEach(e => e.remove());
    const modal = new bootstrap.Modal(
      document.getElementById(modalId)!,
      {
        backdrop: 'static',
        keyboard: false,
        focus: true
      }
    );
    modal.show();
  }

  getVendorProducts() {
    this.loaderIcon = Promise.resolve(true);
    const sub = this.vendorService.GetVendorProductsById(this.vendorId).subscribe((res: any) => {
      if (res) {
        this.vendorProducts = res.body;
        this.defaultProduct = this.vendorProducts[0].VProductId;
        this.loaderIcon = Promise.resolve(false);
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  numberOnly(event): boolean {
    return this.customCurrency.customCurrencyInput(event)
  }

  async selectBooth(args, item: any) {
    this.renewAllBoothsFromGrid = false;
    this.extendingBooth = false;
    item.isSelected = !item.isSelected;
    if (args.srcElement.checked) {
      this.loadHourGlassLoader = Promise.resolve(true);
      this.operationRentalService.getRecordFromTemp().subscribe(async (response: any[]) => {
        const dataFromTemp = response;
        var marketDay;
        const rentalDates = [];
        var currentMonthRentalDates = [];
        var rentalstartDate = "";
        var marketDays = 0;

        for (const el of this.selectedMarketDays) {
          var startDate = new Date(this.rentalForm.controls['boothSearchScreen'].value['rentalStartDates1']);
          const endMonth = this.rentalForm.controls['boothSearchScreen'].value['rentalEndMonth'];
          const [endMonthDate, endMonthYear] = endMonth.split(' ');
          const endMonthIndex = this.getMonthIndex(endMonthDate);
          var endDate = new Date(endMonthYear, endMonthIndex + 1, 0);
          const selectedDayOfWeek = el - 1;
          let currentDay = new Date(startDate);
          while (new Date(this.datePipe.transform(currentDay, 'MM/dd/yyyy')) <= new Date(this.datePipe.transform(endDate, 'MM/dd/yyyy'))) {
            if (currentDay.getDay() === selectedDayOfWeek) {
              if (!rentalstartDate) {
                rentalstartDate = this.datePipe.transform(new Date(currentDay), 'MMM d, y');
              }
              marketDays += 1;
              rentalDates.push({ startDate: this.datePipe.transform(new Date(currentDay), 'MMM d, y') });
            }

            currentDay.setDate(currentDay.getDate() + 1);
          }
        }

        const compareDates = (a: DateString, b: DateString): number => {
          const dateA = new Date(a.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
          const dateB = new Date(b.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
          return dateA - dateB;
        };
        const sortedDates = rentalDates.sort(compareDates);

        currentMonthRentalDates = rentalDates;

        var boothSelectedByOtherUser = false;
        if (dataFromTemp.length > 0) {
          dataFromTemp.forEach(element => {
            const startDate = new Date(element.StartDate);
            const endDate = new Date(element.EndDate);
            const marketDaysOfTemprecord = [];
            element.Sunday ? marketDaysOfTemprecord.push(1) : 0;
            element.Monday ? marketDaysOfTemprecord.push(2) : 0;
            element.Tuesday ? marketDaysOfTemprecord.push(3) : 0;
            element.Wednesday ? marketDaysOfTemprecord.push(4) : 0;
            element.Thursday ? marketDaysOfTemprecord.push(5) : 0;
            element.Friday ? marketDaysOfTemprecord.push(6) : 0;
            element.Saturday ? marketDaysOfTemprecord.push(7) : 0;
            const rentedBoothDates = [];
            marketDaysOfTemprecord.map((el, i) => {
              const dayOfWeek = el - 1;
              while (new Date(startDate) <= new Date(endDate)) {
                if (startDate.getDay() === dayOfWeek) {
                  rentedBoothDates.push(this.datePipe.transform(new Date(startDate), 'MMM d, y'));
                }
                startDate.setDate(startDate.getDate() + 1);
              }
            });

            const sunday = this.rentalForm.controls['boothSearchScreen'].get('marketDaysSunday')?.value ?? false;
            const monday = this.rentalForm.controls['boothSearchScreen'].get('marketDaysMonday')?.value ?? false;
            const tuesday = this.rentalForm.controls['boothSearchScreen'].get('marketDaysTuesday')?.value ?? false;
            const wednesday = this.rentalForm.controls['boothSearchScreen'].get('marketDaysWednesday')?.value ?? false;
            const thursday = this.rentalForm.controls['boothSearchScreen'].get('marketDaysThursday')?.value ?? false;
            const friday = this.rentalForm.controls['boothSearchScreen'].get('marketDaysFriday')?.value ?? false;
            const saturday = this.rentalForm.controls['boothSearchScreen'].get('marketDaysSaturday')?.value ?? false;

            const isDateIncluded = rentalDates.some(rentalDate => {
              const startDate = rentalDate.startDate;
              return rentedBoothDates.includes(startDate);
            });
            if (isDateIncluded && element.BoothNo == item.BoothNumber && element.TempRecordNo != this.tempRecordNo
              && (element.Sunday == sunday || element.Monday == monday || element.Tuesday == tuesday
                || element.Wednesday == wednesday || element.Thursday == thursday || element.Friday == friday || element.Saturday == saturday)
            ) {
              boothSelectedByOtherUser = true;
            }
          });
          if (boothSelectedByOtherUser) {
            item.boothChecked = false;
            Swal.fire({
              text: $localize`This booth has been already selected by another user`,
              icon: "warning",
              confirmButtonText: $localize`Ok`,
            });
          } else {
            this.selectedMonthlyBoothData.push(
              {
                BoothNumber: item.BoothNumber,
                BoothType: item.BoothType,
                BoothTypeId: item.BoothTypeId,
                Sunday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysSunday').value,
                Monday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysMonday').value,
                Tuesday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysTuesday').value,
                Wednesday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysWednesday').value,
                Thursday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysThursday').value,
                Friday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysFriday').value,
                Saturday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysSaturday').value,
                RentalStartDate: this.datePipe.transform(new Date(this.rentalForm.controls['boothSearchScreen'].value['rentalStartDates1']), 'MMM d, y'),
                MarketDay: marketDay,
                NoOfMarketDays: marketDays,
                StartDateList: currentMonthRentalDates,
                AllRentalDates: rentalDates.map(el => new Date(el.startDate)),
                RentalEndDate: rentalDates[rentalDates.length - 1].startDate
              });
            this.isMonthlyboothSelected = this.selectedMonthlyBoothData.length > 0 ? false : true;
            this.insertDataToTemp(item.BoothNumber, this.rentalForm.controls['boothSearchScreen'].value['rentalStartDates1'], rentalDates[rentalDates.length - 1].startDate, '');
            var selectedBoothsForRental = {
              BoothNumber: item.BoothNumber,
              StartDate: this.rentalForm.controls['boothSearchScreen'].value['rentalStartDates1'],
              EndDate: rentalDates[rentalDates.length - 1].startDate
            }
            this.selectedBoothsForRental.push(selectedBoothsForRental);
          }
        }
        else if (rentalstartDate) {
          this.selectedMonthlyBoothData.push(
            {
              BoothNumber: item.BoothNumber,
              BoothType: item.BoothType,
              BoothTypeId: item.BoothTypeId,
              Sunday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysSunday')?.value,
              Monday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysMonday')?.value,
              Tuesday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysTuesday')?.value,
              Wednesday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysWednesday')?.value,
              Thursday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysThursday')?.value,
              Friday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysFriday')?.value,
              Saturday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysSaturday')?.value,
              RentalStartDate: this.datePipe.transform(new Date(this.rentalForm.controls['boothSearchScreen'].value['rentalStartDates1']), 'MMM d, y'),
              MarketDay: marketDay,
              NoOfMarketDays: marketDays,
              StartDateList: currentMonthRentalDates,
              RentalEndDate: rentalDates[rentalDates.length - 1].startDate,
              AllRentalDates: rentalDates.map(el => new Date(el.startDate))
            });
          this.insertDataToTemp(item.BoothNumber, this.rentalForm.controls['boothSearchScreen'].value['rentalStartDates1'], rentalDates[rentalDates.length - 1].startDate, '');
          var selectedBoothsForRental = {
            BoothNumber: item.BoothNumber,
            StartDate: this.rentalForm.controls['boothSearchScreen'].value['rentalStartDates1'],
            EndDate: rentalDates[rentalDates.length - 1].startDate
          }
          this.selectedBoothsForRental.push(selectedBoothsForRental);
        }
        this.isMonthlyboothSelected = this.selectedMonthlyBoothData.length > 0 ? false : true;
        this.loadHourGlassLoader = Promise.resolve(false);
      });
    } else {
      this.loadHourGlassLoader = Promise.resolve(true);
      const index = this.selectedMonthlyBoothData.findIndex(selectedBooth => selectedBooth.BoothNumber === item.BoothNumber);
      if (index !== -1) {
        this.selectedMonthlyBoothData.splice(index, 1);
        this.isMonthlyboothSelected = this.selectedMonthlyBoothData.length > 0 ? false : true;
        if (this.tempRecordNo) {
          const rentalDates = [];
          var rentalstartDate = "";
          for (const el of this.selectedMarketDays) {
            var marketDays = 0;
            const startDate = new Date(this.rentalForm.controls['boothSearchScreen'].value['rentalStartDates1']);
            const endMonth = this.rentalForm.controls['boothSearchScreen'].value['rentalEndMonth'];
            const [endMonthDate, endMonthYear] = endMonth.split(' ');
            const endMonthIndex = this.getMonthIndex(endMonthDate);
            var endDate = new Date(endMonthYear, endMonthIndex + 1, 0);
            const selectedDayOfWeek = el - 1;
            let currentDay = new Date(startDate);
            while (currentDay <= endDate) {
              if (currentDay.getDay() === selectedDayOfWeek) {
                if (!rentalstartDate) {
                  rentalstartDate = this.datePipe.transform(new Date(currentDay), 'MMM d, y');
                }
                marketDays += 1;
                rentalDates.push({ startDate: this.datePipe.transform(new Date(currentDay), 'MMM d, y') });
              }
              currentDay.setDate(currentDay.getDate() + 1);
            }
          };
          const compareDates = (a: DateString, b: DateString): number => {
            const dateA = new Date(a.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
            const dateB = new Date(b.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
            return dateA - dateB;
          };
          const sortedDates = rentalDates.sort(compareDates);
          const temp = {
            TempRecordNo: this.tempRecordNo.toString(),
            BoothNo: item.BoothNumber,
            StartDate: new Date(rentalDates[0].startDate),
            RentalType: 4,
            EndDate: new Date(rentalDates[rentalDates.length - 1].startDate),
            Sunday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysSunday')?.value,
            Monday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysMonday')?.value,
            Tuesday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysTuesday')?.value,
            Wednesday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysWednesday')?.value,
            Thursday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysThursday')?.value,
            Friday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysFriday')?.value,
            Saturday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysSaturday')?.value
          }
          this.subscriptions.push(
            this.operationRentalService.deleteFromTemp(temp).subscribe((res: any) => {
            })
          );
        }
      }
      this.loadHourGlassLoader = Promise.resolve(false);
    }
  }

  productChange(data) {
    var index = this.selectedMonthlyBooths.findIndex(e => e.RentStartPeriod == data.RentStartPeriod && e.RentEndPeriod == data.RentEndPeriod
      && e.BoothNumber == data.BoothNumber)
    if (index !== -1) {
      this.selectedMonthlyBooths[index].Product = data.Product;
      this.gridMonthlyRental.refresh();
      this.disableSave = false;
      this.isFormDirty.emit(true);
    }
  }

  insertDataToTemp(BoothNumber, RentalStartDate, RentalEndDate, el) {
    var tempData = [];
    tempData.push({
      BoothNo: BoothNumber,
      TempRecordNo: this.tempRecordNo.toString(),
      StartDate: new Date(RentalStartDate),
      EndDate: new Date(RentalEndDate),
      Sunday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysSunday')?.value,
      Monday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysMonday')?.value,
      Tuesday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysTuesday')?.value,
      Wednesday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysWednesday')?.value,
      Thursday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysThursday')?.value,
      Friday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysFriday')?.value,
      Saturday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysSaturday')?.value,
      RentalRenewal: true,
      BoothSearch: true,
      IsOnline: false
    });
    this.subscriptions.push(this.operationRentalService.insertDataToTemp(tempData).subscribe((res: any) => {
    }));
  }

  getRentalPaymentSettings() {
    this.loaderIcon = Promise.resolve(true);
    const sub = this.operationRentalService.getRentalSettings().subscribe((res: any) => {
      if (res) {
        this.warnZeroPayment = res.WarnZeroPayment;
        this.displayOtherChargeByBooth = res.DisplayOtherChargesByBooth;
        this.displayCityTax = res.RentalSecondTaxable;
        this.displaySalesTax = res.RentalTaxable;
        this.gridMonthlyRental.getColumnByField("SalesTax").visible = this.displaySalesTax;
        this.gridMonthlyRental.getColumnByField("CityTax").visible = this.displayCityTax;
        this.gridMonthlyRental.refreshColumns();
        this.displayOtherChargeSalesTax = res.OtherRentalTaxable;
        this.displayOtherChargeCityTax = res.OtherRentalSecondTaxable;
        this.gridOtherRental.getColumnByField("BoothNo").visible = res.DisplayOtherChargesByBooth;
        this.gridOtherRental.getColumnByField("SalesTax").visible = this.displayOtherChargeSalesTax;
        this.gridOtherRental.getColumnByField("CityTax").visible = this.displayOtherChargeCityTax;
        this.gridOtherRental.refreshColumns();
        this.masterRentChargeforResOtherItems = res.MasterChargeForOtherChargeRenewal;
        this.PromptRenewOther = res.PromptRenewOther
        this.secondTaxName = res.SecondTaxName ? res.SecondTaxName : "Sec Level Tax"
        var secLevelTaxRentHeader = this.gridMonthlyRental.getColumnByField("CityTax");
        secLevelTaxRentHeader.headerText = this.secondTaxName;
        var secLevelTaxOtherRentHeader = this.gridOtherRental.getColumnByField("CityTax");
        secLevelTaxOtherRentHeader.headerText = this.secondTaxName;
        this.RentalTaxPercentage = res.RentalTaxPercentage;
        this.OtherRentalTaxPercentage = res.OtherRentalTaxPercentage;
        this.RentalSecondTaxPercentage = res.RentalSecondTaxPercentage;
        this.OtherRentalSecondTaxPercentage = res.OtherRentalSecondTaxPercentage;
      }
    });
  }

  getVendorBalances() {
    this.subscriptions.push(this.vendorService.getVendorBalances(this.vendorId).subscribe(res => {
      if (res) {
        this.priorBalance = res.PriorBalance == null ? 0 : res.PriorBalance;
        this.rentalForm.controls['vendorBalances'].patchValue({
          vendorPriorBalance: this.customCurrency.transform(res.PriorBalance == null ? '0.00' : res.PriorBalance),
          totalCharge: this.customCurrency.transform(res.PriorBalance == null ? '0.00' : res.PriorBalance)
        });
      }
    }));
  }

  getOtherRentalItems() {
    this.operationRentalService.getOtherRentalItems().subscribe((response) => {
      if (response) {
        response.map((el, i) => {
          const ob = {
            Id: el.OtherItemId,
            OtherItem: el.OtherItem,
            OtherItemCharge: this.customCurrency.transform(el.OtherItemCombinedMonthlyCharge),
            DefaultOtherItemCharge: this.customCurrency.transform(el.OtherItemCombinedMonthlyCharge),
            DefaultRecurring: el.Recurring,
            Quantity: 0,
            OtherItemtotal: this.customCurrency.transform('0'),
            Recurring: el.Recurring,
            othChgBooths: "none",
            isOtherItemChecked: false
          }
          this.otherRentalCharges.push(ob);
        });

        this.otherRentalCharges = [...this.otherRentalCharges];  // <== important
        this.otherItemList = [...this.otherRentalCharges];
      }
    }, (err) => {
    });
  }

  otherItemUpdate(selectedItems) {
    if (selectedItems.isOtherItemChecked) {
      const rentalMonth = this.rentalForm.controls['otherItemsScreen'].get('otherChargeMarketMonth')?.value;

      const index = this.selectedOtherCharges.findIndex(
        item =>
          item.Id === selectedItems.Id &&
          item.RentalMonth === rentalMonth &&
          item.othChgBooths === selectedItems.othChgBooths
      );

      const isNegative = selectedItems.OtherItemCharge.includes('(') && selectedItems.OtherItemCharge.includes(')');
      const totalValue = parseFloat(selectedItems.OtherItemCharge.replace(/[^0-9.-]/g, ''));
      const finalCharge = isNegative ? -totalValue : totalValue;
      selectedItems.OtherItemCharge = this.customCurrency.transform(finalCharge.toString())
      selectedItems.OtherItemtotal = this.customCurrency.transform((finalCharge * selectedItems.Quantity).toString())

      const obj = {
        Id: selectedItems.Id,
        OtherItem: selectedItems.OtherItem,
        OtherItemCharge: selectedItems.OtherItemCharge,
        Quantity: Number(selectedItems.Quantity) || 0,
        OtherItemtotal: selectedItems.OtherItemtotal,
        othChgBooths: selectedItems.othChgBooths,
        Recurring: selectedItems.Recurring,
        RentalMonth: rentalMonth,
        Reference: selectedItems.Reference ?? ''
      };

      if (index !== -1) {
        // Update the existing selection.
        this.selectedOtherCharges[index] = obj;
      } else {
        // Add a new selection.
        this.selectedOtherCharges.push(obj);
      }

    }
  }

  setDefaultRentalItem(args, selectedItems) {
    selectedItems.Quantity = 0
    selectedItems.OtherItemtotal = 0
    if (args.srcElement.checked) {
      selectedItems.true = true;
      selectedItems.Quantity = 1
      const isNegative = selectedItems.OtherItemCharge.includes('(') && selectedItems.OtherItemCharge.includes(')');
      const totalValue = parseFloat(selectedItems.OtherItemCharge.replace(/[^0-9.-]/g, ''));
      const finalCharge = isNegative ? -totalValue : totalValue;
      selectedItems.OtherItemtotal = this.customCurrency.transform((finalCharge * selectedItems.Quantity).toString());
      this.selectedOtherCharges.push({
        Id: selectedItems.Id,
        OtherItem: selectedItems.OtherItem,
        OtherItemCharge: selectedItems.OtherItemCharge,
        Quantity: selectedItems.Quantity,
        OtherItemtotal: selectedItems.OtherItemtotal,
        othChgBooths: selectedItems.othChgBooths,
        Recurring: selectedItems.Recurring,
        RentalMonth: this.rentalForm.controls['otherItemsScreen'].value['otherChargeMarketMonth']
      });
    } else {
      selectedItems.true = false;
      const index = this.selectedOtherCharges.findIndex(item => item.Id === selectedItems.Id);
      if (index !== -1) {
        this.selectedOtherCharges.splice(index, 1);
      }
    }
  }

  deleteOtherRentalCharges(data) {
    if (data.Status == "R") {
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Are you sure you want to delete the reservation?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: $localize`Yes`,
        cancelButtonText: $localize`No`,
      }).then((result) => {
        if (result.value) {
          const index = this.selectedOtherItems.findIndex(oth => oth.Id === data.Id && oth.RentalMonth == data.RentalMonth);
          if (index !== -1) {
            this.selectedOtherItems.splice(index, 1);
            this.totalOtherRentalCharge -= this.getActualAmountFromInp(data.OtherItemtotal);
            this.totalSalesTax -= this.getActualAmountFromInp(data.SalesTax);
            this.totalSecondLeveltax -= this.getActualAmountFromInp(data.CityTax);
            this.setRentalCharges();
            this.gridOtherRental.refresh();
          }

          Swal.fire({
            title: $localize`Warning`,
            text: $localize`Do you want to cancel the reservation?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: $localize`Yes`,
            cancelButtonText: $localize`No`,
          }).then((result) => {
            if (result.value) {
              var obj = {
                OtherItemId: data.Id,
                VendorId: this.vendorId
              }
              this.subscriptions.push(this.operationRentalService.deleteCombinedMonthlyOtherItemReservation(obj).subscribe((res: any) => {
                if (res.Success) {
                  this.toastr.success($localize`Reservation has been cancelled successfully`, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
                }
                else {
                  this.toastr.error($localize`Error occured while cancelling the reservation`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
                }
              }));
            }
          });
        }
      });
    }
    else if (!data.NewItem) {
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Old Booking cannot be deleted`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
    }
    else {
      Swal.fire({
        title: $localize`Confirm`,
        text: $localize`Are you sure you want to delete the selected Other Charges`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: $localize`Yes`,
        cancelButtonText: $localize`No`,
      }).then((result) => {
        if (result.value) {
          const index = this.selectedOtherItems.findIndex(oth => oth.Id === data.Id && oth.RentalMonth == data.RentalMonth && oth.NewItem && (oth.Reference ?? "") == (data.Reference ?? ""));
          if (index !== -1) {
            this.selectedOtherItems.splice(index, 1);
          }

          var selectedItems = this.otherRentalCharges.findIndex(item => item.Id == data.Id);
          if (selectedItems != -1) {
            this.operationRentalService.getOtherRentalItems().subscribe((response) => {
              if (response) {
                const masterChargeRecord = response.filter(item => item.OtherItemId == data.Id);
                if (masterChargeRecord) {
                  this.otherRentalCharges[selectedItems].Quantity = 0;
                  this.otherRentalCharges[selectedItems].othChgBooths = "none";
                  this.otherRentalCharges[selectedItems].OtherItemCharge = this.customCurrency.transform(masterChargeRecord[0].OtherItemCombinedMonthlyCharge);
                  this.otherRentalCharges[selectedItems].OtherItemtotal = this.customCurrency.transform('0');
                  this.otherRentalCharges[selectedItems].Reference = ""
                  this.otherRentalCharges[selectedItems].Recurring = masterChargeRecord[0].Recurring
                }
              }
            }, (err) => {
            });
          }
          this.totalOtherRentalCharge -= this.getActualAmountFromInp(data.OtherItemtotal);
          this.totalSalesTax -= this.getActualAmountFromInp(data.SalesTax);
          this.totalSecondLeveltax -= this.getActualAmountFromInp(data.CityTax);
          this.setRentalCharges();
          this.gridOtherRental.refresh();
        }
      });
    }
  }

  calculateDaysDifference(rentalStartDate: Date, rentalEndDate: Date): number {
    //const currentDate = new Date();
    const difference = Math.ceil((rentalEndDate.getTime() - rentalStartDate.getTime()) / (1000 * 3600 * 24));
    const daysDifference = difference + 1;
    return daysDifference;
  }

  getMarketDaysSettings() {
    this.marketDaysEnabled = [];
    this.marketInfoService.getMarketDaysSettings().subscribe((response) => {
      if (!response) return;

      const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const boothForm = this.rentalForm.controls['boothSearchScreen'];

      // Enable/disable controls, update values, manage grid columns
      days.forEach((day, index) => {
        const isEnabled = response[day];
        const control = boothForm.get(`marketDays${day}`);

        isEnabled ? control.enable() : control.disable();
        control.setValue(true);
        this.gridMonthlyRental.getColumnByField(day).visible = isEnabled;

        if (isEnabled) this.marketDaysEnabled.push(index);
      });

      this.gridMonthlyRental.refreshColumns();

      // Handle rental range validation
      const [endMonthName, endYear] = boothForm.value['rentalEndMonth'].split(' ');
      const endDate = new Date(endYear, this.getMonthIndex(endMonthName) + 1, 0);
      const rentalStartDate = new Date();
      const daysDiff = this.calculateDaysDifference(rentalStartDate, endDate);

      if (daysDiff <= 7) {
        days.forEach(day => {
          const control = boothForm.get(`marketDays${day}`);
          //control.setValue(false);
          control.disable();
        });

        let currentDay = new Date(rentalStartDate);
        while (currentDay.setHours(0, 0, 0, 0) <= endDate.setHours(0, 0, 0, 0)) {
          const dayIndex = currentDay.getDay();
          if (this.marketDaysEnabled.includes(dayIndex)) {
            const dayName = days[dayIndex];
            const control = boothForm.get(`marketDays${dayName}`);
            control.enable();
            control.setValue(true);
          }
          currentDay.setDate(currentDay.getDate() + 1);
        }
      }

      this.selectedMonthlyMarketDays();
    });
  }

  resetAvailableBooths() {
    this.allAvailableBooths = [];
  }

  getDateFromDateTime(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  getMonthlyMarkets() {
    this.subscriptions.push(this.operationRentalService.getMonthlyMarketDays().subscribe(res => {
      if (res) {
        this.monthlyMarketDays = res;
      }

      this.rentalForm.controls['boothSearchScreen'].patchValue({
        rentalStartMonth: res[0].RentalMonths,
        rentalEndMonth: res[0].RentalMonths,
      }),
        this.rentalForm.controls['otherItemsScreen'].patchValue({
          otherChargeMarketMonth: res[0].RentalMonths
        })
      this.checkRentalMonths();
      this.getMonthlyRental();
    }));
  }

  isDateSelected(item: any): boolean {
    var isItemSelected = this.selectedOtherItems.some(
      (element) =>
        (element.RentalMonth === this.rentalForm.controls['otherItemsScreen'].value['otherChargeMarketMonth']) &&
        element.Id === item.Id && element.NewItem == true
    );

    if (!isItemSelected) {
      isItemSelected = this.selectedOtherCharges.some(
        (element) =>
          (element.RentalMonth === this.rentalForm.controls['otherItemsScreen'].value['otherChargeMarketMonth']) &&
          element.Id === item.Id
      );
    }

    !isItemSelected ? item.otherItemChecked = false : item.otherItemChecked = true;
    // item.othChgBooths = "none";
    return isItemSelected;
  }

  checkRentalMonths() {
    this.allAvailableBooths = [];
    if (this.rentalForm.controls['boothSearchScreen'].value['rentalStartMonth'] && this.rentalForm.controls['boothSearchScreen'].value['rentalEndMonth']) {
      const startMonth = this.rentalForm.controls['boothSearchScreen'].value['rentalStartMonth'];
      const endMonth = this.rentalForm.controls['boothSearchScreen'].value['rentalEndMonth'];
      const [startMonthDate, startYear] = startMonth.split(' ');
      const [endMonthDate, endMonthYear] = endMonth.split(' ');
      const startMonthIndex = this.getMonthIndex(startMonthDate);
      const endMonthIndex = this.getMonthIndex(endMonthDate);
      if (endMonthYear < startYear || (endMonthYear == startYear && endMonthIndex < startMonthIndex)) {
        this.rentalForm.controls['boothSearchScreen'].get('rentalEndMonth').setValue(startMonth);
      }
      this.getMarketDaysSettings();
    }
  }

  getMonthIndex(monthString: string): number {
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const monthIndex = months.findIndex(month => month.toLowerCase() === monthString.toLowerCase());
    return monthIndex !== -1 ? monthIndex : 0;
  }

  getMonthEndDate(inputDate: Date): Date {
    const nextMonthFirstDay = new Date(inputDate);
    nextMonthFirstDay.setMonth(nextMonthFirstDay.getMonth() + 1, 1);
    const monthEndDate = new Date(nextMonthFirstDay);
    monthEndDate.setDate(monthEndDate.getDate() - 1);
    return monthEndDate;
  }

  hideMonthCoulmnsInBoothGrid() {
    this.gridMonthlyRental.getColumnByField("January").visible = false;
    this.gridMonthlyRental.getColumnByField("February").visible = false;
    this.gridMonthlyRental.getColumnByField("March").visible = false;
    this.gridMonthlyRental.getColumnByField("April").visible = false;
    this.gridMonthlyRental.getColumnByField("May").visible = false;
    this.gridMonthlyRental.getColumnByField("June").visible = false;
    this.gridMonthlyRental.getColumnByField("July").visible = false;
    this.gridMonthlyRental.getColumnByField("August").visible = false;
    this.gridMonthlyRental.getColumnByField("September").visible = false;
    this.gridMonthlyRental.getColumnByField("October").visible = false;
    this.gridMonthlyRental.getColumnByField("November").visible = false;
    this.gridMonthlyRental.getColumnByField("December").visible = false;
    setTimeout(() => {
      this.gridMonthlyRental.refresh();
    }, 0);
  }

  async getMonthlyRental() {
    this.loaderIcon = Promise.resolve(true);
    this.selectedMonthlyBooths = [];
    var existingBooths = [];
    this.hideMonthCoulmnsInBoothGrid();
    var res = await lastValueFrom(this.operationRentalService.getMonthlyBookings(this.vendorId));
    if (res) {
      existingBooths = res;
      const currentDate: Date = this.getDateFromDateTime(new Date());
      for (const el of existingBooths) {
        const StartDateList = [];
        var initialStartDate;
        var marketDays = 0;
        var marketDay;
        const today: Date = currentDate;

        var startDate = new Date(el.RentalStartDate);
        var endDate = new Date(el.RentalEndDate);

        if (el.Status == "R" && startDate < today) {
          startDate = today;
          initialStartDate = startDate;
          endDate = this.getMonthEndDate(startDate);
        }

        let foundMarketDay = false;
        let monthsSearched = 0;
        const maxMonthsToSearch = 24;
        while (!foundMarketDay && this.selectedMarketDays.length > 0 && monthsSearched < maxMonthsToSearch) {
          for (const date of this.selectedMarketDays) {
            const selectedDayOfWeek = date - 1;
            marketDay = this.datePipe.transform(el.RentalStartDate, 'EEE');
            let currentDay = new Date(startDate);

            while (currentDay <= endDate) {
              if (currentDay.getDay() === selectedDayOfWeek) {
                marketDays += 1;
                StartDateList.push({
                  startDate: this.datePipe.transform(new Date(currentDay), 'MMM d, y')
                });
                foundMarketDay = true;
              }
              currentDay.setDate(currentDay.getDate() + 1);
            }
          }

          if (!foundMarketDay) {
            endDate.setDate(endDate.getDate() + 1);
            endDate = this.getMonthEndDate(endDate);
            monthsSearched++;
          }
        }

        const compareDates = (a: DateString, b: DateString): number => {
          const dateA = new Date(a.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
          const dateB = new Date(b.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
          return dateA - dateB;
        };

        const sortedDates = StartDateList.sort(compareDates);

        if (el.Status == "R") {
          if (initialStartDate <= today && sortedDates.length > 0) {
            el.RentalStartDate = StartDateList[0].startDate
            el.RentalEndDate = StartDateList[StartDateList.length - 1].startDate;
          }
        }

        if (el.Status == "R") {
          var obj = {
            BoothTypeId: el.BoothTypeId,
            VendorId: this.vendorId,
            RentalStartPeriod: new Date(el.RentalStartDate),
            RentalEndPeriod: new Date(el.RentalEndDate)
          }
          const res = await this.operationRentalService.getBoothRentalCombinedMonthlyCharges(obj).toPromise();
          if (res) {
            this.resetRentMonthsInGrid(res);
            this.gridMonthlyRental.refresh();
            const ob = {
              MonthlyRentalId: el.MonthlyRentalId,
              BoothNumber: el.BoothNumber,
              BoothType: el.BoothType,
              BoothTypeId: el.BoothTypeId,
              RentalStartDate: this.datePipe.transform(el.RentalStartDate, 'MMM d, y'),
              RentalEndDate: this.datePipe.transform(el.RentalEndDate, 'MMM d, y'),
              RentalSavedEndDate: this.datePipe.transform(el.RentalStartDate, 'MMM d, y'),
              RentStartPeriod: this.datePipe.transform(el.RentalStartDate, 'MMMM yyyy'),
              RentEndPeriod: this.datePipe.transform(el.RentalEndDate, 'MMMM yyyy'),
              Product: el.ProductId,
              StartDateList: StartDateList,
              MktDays: marketDays,
              PerDiemRent: this.customCurrency.transform('0.00'),
              Rent: this.customCurrency.transform(res.Rent),
              SalesTax: this.customCurrency.transform(res.SalesTax),
              CityTax: this.customCurrency.transform(res.CityTax),
              Sunday: el.Sunday,
              Monday: el.Monday,
              Tuesday: el.Tuesday,
              Wednesday: el.Wednesday,
              Thursday: el.Thursday,
              Friday: el.Friday,
              Saturday: el.Saturday,
              Reservation: el.BoothReserved,
              Drop: el.DoNotRenew,
              January: this.customCurrency.transform(res.JanRent),
              February: this.customCurrency.transform(res.FebRent),
              March: this.customCurrency.transform(res.MarRent),
              April: this.customCurrency.transform(res.AprRent),
              May: this.customCurrency.transform(res.MayRent),
              June: this.customCurrency.transform(res.JunRent),
              July: this.customCurrency.transform(res.JulRent),
              August: this.customCurrency.transform(res.AugRent),
              September: this.customCurrency.transform(res.SepRent),
              October: this.customCurrency.transform(res.OctRent),
              November: this.customCurrency.transform(res.NovRent),
              December: this.customCurrency.transform(res.DecRent),
              JanuaryMonthPresent: res.JanuaryMonthPresent,
              FebruaryMonthPresent: res.FebruaryMonthPresent,
              MarchMonthPresent: res.MarchMonthPresent,
              AprilMonthPresent: res.AprilMonthPresent,
              MayMonthPresent: res.MayMonthPresent,
              JuneMonthPresent: res.JuneMonthPresent,
              JulyMonthPresent: res.JulyMonthPresent,
              AugustMonthPresent: res.AugustMonthPresent,
              SeptemberMonthPresent: res.SeptemberMonthPresent,
              OctoberMonthPresent: res.OctoberMonthPresent,
              NovemberMonthPresent: res.NovemberMonthPresent,
              DecemberMonthPresent: res.DecemberMonthPresent,
              DisableJanMonth: res.JanRent ? false : true,
              DisableFebMonth: res.FebRent ? false : true,
              DisableMarMonth: res.MarRent ? false : true,
              DisableAprMonth: res.AprRent ? false : true,
              DisableMayMonth: res.MayRent ? false : true,
              DisableJunMonth: res.JunRent ? false : true,
              DisableJulMonth: res.JulRent ? false : true,
              DisableAugMonth: res.AugRent ? false : true,
              DisableSepMonth: res.SepRent ? false : true,
              DisableOctMonth: res.OctRent ? false : true,
              DisableNovMonth: res.NovRent ? false : true,
              DisableDecMonth: res.DecRent ? false : true,
              DiasbleStartDate: false,
              Status: el.Status,
              NewBooth: false,
              ExtendRental: true,
              AllRentalDates: StartDateList.map(el => new Date(el.startDate)),
              TaxModel: res.TaxModel
            }
            this.totalRentalCharge += this.getActualAmountFromInp(res.Rent);
            this.totalSalesTax += this.getActualAmountFromInp(res.SalesTax);
            this.totalSecondLeveltax += this.getActualAmountFromInp(res.CityTax);
            this.setRentalCharges();
            this.selectedMonthlyBooths.push(ob);
            this.gridMonthlyRental.refresh();
          }
          this.disableSave = false;
        }
        else {
          this.resetRentMonthsInGrid(el);

          var rentalStartPeriod;
          rentalStartPeriod = this.datePipe.transform(el.RentalStartDate, 'MMMM yyyy');

          const ob = {
            MonthlyRentalId: el.MonthlyRentalId,
            BoothNumber: el.BoothNumber,
            BoothType: el.BoothType,
            BoothTypeId: el.BoothTypeId,
            RentalStartDate: this.datePipe.transform(el.RentalStartDate, 'MMM d, y'),
            RentalEndDate: this.datePipe.transform(el.RentalEndDate, 'MMM d, y'),
            RentalSavedEndDate: this.datePipe.transform(el.RentalEndDate, 'MMM d, y'),
            RentStartPeriod: rentalStartPeriod,
            RentEndPeriod: this.datePipe.transform(el.RentalEndDate, 'MMMM yyyy'),
            Product: el.ProductId,
            StartDateList: StartDateList,
            MktDays: 0,
            PerDiemRent: this.customCurrency.transform('0.00'),
            Rent: this.customCurrency.transform('0.00'),
            SalesTax: this.customCurrency.transform('0.00'),
            CityTax: this.customCurrency.transform('0.00'),
            Sunday: el.Sunday,
            Monday: el.Monday,
            Tuesday: el.Tuesday,
            Wednesday: el.Wednesday,
            Thursday: el.Thursday,
            Friday: el.Friday,
            Saturday: el.Saturday,
            Reservation: el.BoothReserved,
            Drop: el.DoNotRenew,
            Status: el.Status,
            January: this.customCurrency.transform('0.00'),
            February: this.customCurrency.transform('0.00'),
            March: this.customCurrency.transform('0.00'),
            April: this.customCurrency.transform('0.00'),
            May: this.customCurrency.transform('0.00'),
            June: this.customCurrency.transform('0.00'),
            July: this.customCurrency.transform('0.00'),
            August: this.customCurrency.transform('0.00'),
            September: this.customCurrency.transform('0.00'),
            October: this.customCurrency.transform('0.00'),
            November: this.customCurrency.transform('0.00'),
            December: this.customCurrency.transform('0.00'),
            JanuaryMonthPresent: el.JanuaryMonthPresent,
            FebruaryMonthPresent: el.FebruaryMonthPresent,
            MarchMonthPresent: el.MarchMonthPresent,
            AprilMonthPresent: el.AprilMonthPresent,
            MayMonthPresent: el.MayMonthPresent,
            JuneMonthPresent: el.JuneMonthPresent,
            JulyMonthPresent: el.JulyMonthPresent,
            AugustMonthPresent: el.AugustMonthPresent,
            SeptemberMonthPresent: el.SeptemberMonthPresent,
            OctoberMonthPresent: el.OctoberMonthPresent,
            NovemberMonthPresent: el.NovemberMonthPresent,
            DecemberMonthPresent: el.DecemberMonthPresent,
            DisableJanMonth: true,
            DisableFebMonth: true,
            DisableMarMonth: true,
            DisableAprMonth: true,
            DisableMayMonth: true,
            DisableJunMonth: true,
            DisableJulMonth: true,
            DisableAugMonth: true,
            DisableSepMonth: true,
            DisableOctMonth: true,
            DisableNovMonth: true,
            DisableDecMonth: true,
            DiasbleStartDate: true,
            NewBooth: false,
            AllRentalDates: StartDateList.map(el => new Date(el.startDate)),
            TaxModel: null
          }
          this.selectedMonthlyBooths.push(ob);
        }
      };
      this.gridMonthlyRental.refresh();
      this.loaderIcon = Promise.resolve(false);
    }
    this.getMonthlyOtherRentals();
  }

  async getMonthlyOtherRentals() {
    this.loaderIcon = Promise.resolve(true);
    this.selectedOtherItems = [];
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;
    const currentYearMonth = `${currentYear}${currentMonth < 10 ? '0' : ''}${currentMonth}`;
    var res = await lastValueFrom(this.operationRentalService.GetCombinedMonthlyOtherRentals(this.vendorId));
    if (res) {
      this.allrentedOtherItems = res;
      for (const el of res) {
        if (el.YearMonth >= currentYearMonth) {
          const year = parseInt(el.YearMonth.substring(0, 4));
          const month = parseInt(el.YearMonth.substring(4, 6));
          const date = new Date(year, month - 1, 1);
          const formattedDate = this.datePipe.transform(date, 'MMMM yyyy');
          const index = this.selectedOtherItems.findIndex(item => item.Id === el.OtherItemId && item.RentalMonth == formattedDate && item.Reference == el.Reference && item.BoothNo == el.BoothNumber && item.Recurring == el.Recurring);
          if (index !== -1) {
            this.selectedOtherItems[index].Quantity += el.Quantity;
            this.selectedOtherItems[index].MonthlyRentalIds += ',' + el.OtherRentalId
          }
          else {
            const ob = {
              Id: el.OtherItemId,
              MonthOtherRentalId: el.OtherRentalId,
              OtherItem: el.OtherItemName,
              OtherItemCharge: this.customCurrency.transform('0'),
              Quantity: el.Quantity,
              OtherItemtotal: this.customCurrency.transform('0'),
              RentalMonth: formattedDate,
              SalesTax: this.customCurrency.transform('0'),
              CityTax: this.customCurrency.transform('0'),
              BoothNo: el.BoothNumber ? el.BoothNumber : "none",
              Recurring: el.Recurring,
              Reference: el.Reference,
              NewItem: false,
              MonthlyRentalIds: el.OtherRentalId.toString()
            }
            this.selectedOtherItems.push(ob);
          }
        }
        else {
          var obj = {
            OtherItemId: el.OtherItemId,
            VendorId: this.vendorId,
            Quantity: el.Quantity,
            OtherItemCharge: el.OtherCharge
          }
          const date = new Date(currentYear, currentMonth - 1, 1);
          const formattedDate = this.datePipe.transform(date, 'MMMM yyyy');
          const res = await lastValueFrom(this.operationRentalService.getOtherItemsRentalCharges(obj));
          if (res) {
            const ob = {
              Id: el.OtherItemId,
              MonthOtherRentalId: el.OtherRentalId,
              OtherItem: el.OtherItemName,
              OtherItemCharge: this.customCurrency.transform(el.OtherCharge),
              Quantity: el.Quantity,
              OtherItemtotal: this.customCurrency.transform((el.OtherCharge * el.Quantity).toString()),
              RentalMonth: formattedDate,
              SalesTax: this.customCurrency.transform(res.SalesTax.toString()),
              CityTax: this.customCurrency.transform(res.CityTax.toString()),
              BoothNo: el.BoothNumber ? el.BoothNumber : "none",
              Recurring: el.Recurring,
              Reference: el.Reference,
              NewItem: false,
              MonthlyRentalIds: '',
              Status: "R"
            }
            this.disableSave = false;
            this.selectedOtherItems.push(ob);
            this.gridOtherRental.refresh();
            const OtherItemtotal = el.OtherCharge * el.Quantity;
            this.totalOtherRentalCharge += OtherItemtotal;
            this.totalSalesTax += this.getActualAmountFromInp(res.SalesTax);
            this.totalSecondLeveltax += this.getActualAmountFromInp(res.CityTax);
            this.setRentalCharges();
          }
        }
        this.gridOtherRental.refresh();
      }
      this.loaderIcon = Promise.resolve(false);
    }
  }

  checkMarketDay() {
    this.selectedMarketDays.map((el, i) => {
      switch (el) {
        case 1: this.rentalForm.controls['boothSearchScreen'].get('marketDaysSunday').setValue(true);
          this.rentalForm.controls['RentalExtensionForm'].get('marketDaysSunday').setValue(true)
          break;
        case 2: this.rentalForm.controls['boothSearchScreen'].get('marketDaysMonday').setValue(true);
          this.rentalForm.controls['RentalExtensionForm'].get('marketDaysMonday').setValue(true);
          break;
        case 3: this.rentalForm.controls['boothSearchScreen'].get('marketDaysTuesday').setValue(true);
          this.rentalForm.controls['RentalExtensionForm'].get('marketDaysTuesday').setValue(true);
          break;
        case 4: this.rentalForm.controls['boothSearchScreen'].get('marketDaysWednesday').setValue(true);
          this.rentalForm.controls['RentalExtensionForm'].get('marketDaysWednesday').setValue(true);
          break;
        case 5: this.rentalForm.controls['boothSearchScreen'].get('marketDaysThursday').setValue(true);
          this.rentalForm.controls['RentalExtensionForm'].get('marketDaysThursday').setValue(true);
          break;
        case 6: this.rentalForm.controls['boothSearchScreen'].get('marketDaysFriday').setValue(true);
          this.rentalForm.controls['RentalExtensionForm'].get('marketDaysFriday').setValue(true);
          break;
        case 7: this.rentalForm.controls['boothSearchScreen'].get('marketDaysSaturday').setValue(true);
          this.rentalForm.controls['RentalExtensionForm'].get('marketDaysSaturday').setValue(true);
          break;
      }
    });
  }

  checkMarketDaysSelected() {
    const sunday = this.rentalForm.controls['boothSearchScreen'].get('marketDaysSunday')?.value;
    const monday = this.rentalForm.controls['boothSearchScreen'].get('marketDaysMonday')?.value;
    const tuesday = this.rentalForm.controls['boothSearchScreen'].get('marketDaysTuesday')?.value;
    const wednesday = this.rentalForm.controls['boothSearchScreen'].get('marketDaysWednesday')?.value;
    const thursday = this.rentalForm.controls['boothSearchScreen'].get('marketDaysThursday')?.value;
    const friday = this.rentalForm.controls['boothSearchScreen'].get('marketDaysFriday')?.value;
    const saturday = this.rentalForm.controls['boothSearchScreen'].get('marketDaysSaturday')?.value;
    return sunday || monday || tuesday || wednesday || thursday || friday || saturday;
  }

  openLayoutPopup(selectedId) {
    this.displayLayoutPopup = selectedId == 1 ? true : false;
    this.rentalForm.controls['boothSearchScreen'].patchValue({
      boothParts: !this.displayDefaultPart ? (this.displayLayoutPopup ? this.parts[0].PartId : '0') : this.defaultPartId
    })
  }

  openModal(modal) {
    modal.classList.add('show');
    modal.style.display = 'block';
  }

  closeLayoutForm() {
    this.displayLayout = false;
    this.getMarketDaysSettings();
    this.hideTopHeaders.emit(false);
  }

  selectedBoothsFromLayout(data) {
    window.scrollTo(0, 0);
    this.selectedMonthlyBoothData = data;
    this.displayLayout = false;
    this.hideTopHeaders.emit(false);
    this.getMarketDaysSettings();
    this.getRentalPaymentSettings();
    this.addSelectedBoothsToGrid();
  }

  openLayout() {
    this.layoutParts = this.rentalForm.controls['boothSearchScreen'].value['boothParts'];
    var marketDaysSelected = this.checkMarketDaysSelected();
    if (!marketDaysSelected) {
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Please select a market day!`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
    }
    else {
      if (this.selectedMarketDays.length > 0) {
        var selectedDates = [];
        this.selectedMarketDays.map(async (el, i) => {
          const startDate = new Date(this.rentalForm.controls['boothSearchScreen'].value['rentalStartDates1']);
          const endMonth = this.rentalForm.controls['boothSearchScreen'].value['rentalEndMonth'];
          const [endMonthDate, endMonthYear] = endMonth.split(' ');
          const endMonthIndex = this.getMonthIndex(endMonthDate);
          var endDate = new Date(endMonthYear, endMonthIndex + 1, 0);
          const selectedDayOfWeek = el - 1;
          let currentDay = new Date(startDate);
          while (currentDay <= endDate) {
            if (currentDay.getDay() === selectedDayOfWeek) {
              selectedDates.push(this.datePipe.transform(new Date(currentDay), 'MM/dd/yyyy'));
            }
            currentDay.setDate(currentDay.getDate() + 1);
          }

          const compareDates = (a, b): number => {
            const dateA = new Date(a.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
            const dateB = new Date(b.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
            return dateA - dateB;
          };
          const sortedDates = selectedDates.sort(compareDates);
        });
      }
      this.MonthlyLayoutData = {
        Sunday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysSunday')?.value,
        Monday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysMonday')?.value,
        Tuesday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysTuesday')?.value,
        Wednesday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysWednesday')?.value,
        Thursday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysThursday')?.value,
        Friday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysFriday')?.value,
        Saturday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysSaturday')?.value,
        monthlyRentalStartDate: this.rentalForm.controls['boothSearchScreen'].get('rentalStartMonth')?.value,
        monthlyRentalEndDate: this.rentalForm.controls['boothSearchScreen'].get('rentalEndMonth')?.value,
        monthlyRentalMarketDays: this.selectedMarketDays,
        selectedDates: selectedDates,
        monthlyRentalSelectedBooths: this.selectedMonthlyBooths.filter(e => e.NewBooth == true),
        RentalStartDate: this.datePipe.transform(new Date(this.rentalForm.controls['boothSearchScreen'].value['rentalStartDates1']), 'MM/dd/yyyy'),
        RentalEndDate: this.datePipe.transform(new Date(this.rentalStartDates[this.rentalStartDates.length - 1].startDate), 'MM/dd/yyyy'),
        tempRecordNo: this.tempRecordNo
      }

      this.closeModalById('modalAddNewMonthlyBooths');
      this.hideTopHeaders.emit(true);
      this.displayLayout = true;
    }
  }

  closeModalById(modalId: string) {
    const modalEl = document.getElementById(modalId);
    if (modalEl) {
      const modalInstance = window['bootstrap'].Modal.getInstance(modalEl);
      if (modalInstance) {
        modalInstance.hide();
      }
    }
    document.body.classList.remove('modal-open');

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }

  loadAvailableBooths() {
    this.selectedMonthlyBoothData = [];
    var marketDaysSelected = this.checkMarketDaysSelected();
    if (this.selectedBoothsForRental.length > 0) {
      this.selectedBoothsForRental.forEach(ele => {
        const temp = {
          TempRecordNo: this.tempRecordNo.toString(),
          BoothNo: ele.BoothNumber,
          StartDate: new Date(ele.StartDate),
          RentalType: 4,
          EndDate: new Date(ele.EndDate),
          Sunday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysSunday')?.value ?? false,
          Monday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysMonday')?.value ?? false,
          Tuesday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysTuesday')?.value ?? false,
          Wednesday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysWednesday')?.value ?? false,
          Thursday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysThursday')?.value ?? false,
          Friday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysFriday')?.value ?? false,
          Saturday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysSaturday')?.value ?? false
        }
        this.subscriptions.push(
          this.operationRentalService.deleteFromTemp(temp).subscribe((res: any) => {
          })
        );
      });
    }
    this.selectedBoothsForRental = [];
    if (!marketDaysSelected) {
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Please select a market day!`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
    }
    else {
      this.loadHourGlassLoader = Promise.resolve(true);
      var obj;
      var marketDays = '';
      const rentalStartDateYear = new Date(this.rentalForm.controls['boothSearchScreen'].value['rentalStartMonth'].split('-')[0]).getFullYear();
      const rentalStartDateMonth = new Date(this.rentalForm.controls['boothSearchScreen'].value['rentalStartMonth'].split('-')[0]).getMonth() + 1;
      const rentalEndDateYear = new Date(this.rentalForm.controls['boothSearchScreen'].value['rentalEndMonth'].split('-')[0]).getFullYear();
      const rentalEndDateMonth = new Date(this.rentalForm.controls['boothSearchScreen'].value['rentalEndMonth'].split('-')[0]).getMonth() + 1;
      const rentalStartDateYearMonth = `${rentalStartDateYear}${rentalStartDateMonth < 10 ? '0' : ''}${rentalStartDateMonth}`;
      const rentalEndDateYearMonth = `${rentalEndDateYear}${rentalEndDateMonth < 10 ? '0' : ''}${rentalEndDateMonth}`;
      this.selectedMarketDays.forEach(element => {
        marketDays = marketDays.concat(element) + ',';
      });
      obj = {
        Parts: this.rentalForm.controls['boothSearchScreen'].value['boothParts'],
        RentalStartDate: this.datePipe.transform(new Date(this.rentalForm.controls['boothSearchScreen'].value['rentalStartDates1']), 'MM/dd/yyyy'),
        RentalEndDate: this.datePipe.transform(new Date(this.rentalStartDates[this.rentalStartDates.length - 1].startDate), 'MM/dd/yyyy'),
        RentalStartDateYearMonth: rentalStartDateYearMonth,
        RentalEndDateYearMonth: rentalEndDateYearMonth,
        FirstDayOfRentalStartWeek: this.datePipe.transform(new Date(this.rentalForm.controls['boothSearchScreen'].value['rentalStartDates1']), 'MM/dd/yyyy'),
        FirstDayOfRentalEndWeek: this.datePipe.transform(new Date(this.rentalStartDates[this.rentalStartDates.length - 1].startDate), 'MM/dd/yyyy'),
        FirstDayOfRental: this.datePipe.transform(new Date(this.rentalForm.controls['boothSearchScreen'].value['rentalStartDates1']), 'MM/dd/yyyy'),
        MarketDays: marketDays.substring(0, marketDays.length - 1),
        Sunday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysSunday')?.value ? true : false,
        Monday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysMonday')?.value ? true : false,
        Tuesday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysTuesday')?.value ? true : false,
        Wednesday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysWednesday')?.value ? true : false,
        Thursday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysThursday')?.value ? true : false,
        Friday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysFriday')?.value ? true : false,
        Saturday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysSaturday')?.value ? true : false,
      }

      var selectedRentalDates = [];
      this.selectedMarketDays.map(async (el, i) => {
        const startMonth = this.rentalForm.controls['boothSearchScreen'].value['rentalStartMonth'];
        const endMonth = this.rentalForm.controls['boothSearchScreen'].value['rentalEndMonth'];
        const [startMonthDate, startYear] = startMonth.split(' ');
        const [endMonthDate, endMonthYear] = endMonth.split(' ');
        const startMonthIndex = this.getMonthIndex(startMonthDate);
        const endMonthIndex = this.getMonthIndex(endMonthDate);
        const startDate = new Date(startYear, startMonthIndex, 1);
        var endDate = new Date(endMonthYear, endMonthIndex + 1, 0);
        const selectedDayOfWeek = el - 1;
        while (new Date(startDate) <= new Date(endDate)) {
          if (startDate.getDay() === selectedDayOfWeek) {
            selectedRentalDates.push(this.datePipe.transform(new Date(startDate), 'MMM d, y'));
          }
          startDate.setDate(startDate.getDate() + 1);
        }
      });

      this.operationRentalService.getRecordFromTemp().subscribe((response: any[]) => {
        const dataFromTemp = response;
        this.operationRentalService.getAvailableBoothsForCombinedMonthly(obj).subscribe((response) => {
          if (response) {
            this.allAvailableBooths = response.map(b => ({ ...b, boothChecked: false }));
            if (this.allAvailableBooths.length > 0) {
              var rentedBoothDates = [];
              var excludedBoothNumbers = '';
              if (dataFromTemp.length > 0) {
                dataFromTemp.forEach(element => {
                  this.selectedMarketDays.map((el, i) => {
                    var dayOfWeek = el - 1;
                    const startDate = new Date(element.StartDate);
                    const endDate = new Date(element.EndDate);
                    while (new Date(startDate) <= new Date(endDate)) {
                      if (startDate.getDay() === dayOfWeek) {
                        rentedBoothDates.push(this.datePipe.transform(new Date(startDate), 'MMM d, y'));
                      }
                      startDate.setDate(startDate.getDate() + 1);
                    }
                    if (selectedRentalDates.some(el => rentedBoothDates.includes(el))) {
                      this.allAvailableBooths = this.allAvailableBooths.filter(e => e.BoothNumber != element.BoothNo)
                      excludedBoothNumbers += element.BoothNo + ',';
                    }
                  });
                });
              }
            }
            else {
              Swal.fire({
                text: $localize`Booth is not available!`,
                icon: "info",
                confirmButtonText: $localize`Ok`,
              });
            }
          }

          const boothNumber = this.rentalForm.controls['boothSearchScreen'].get('srcBoothNumber').value;
          if (boothNumber) {
            const searchLower = boothNumber.toLowerCase();
            let startIndex = this.allAvailableBooths.findIndex(e =>
              e.BoothNumber.toLowerCase().startsWith(searchLower)
            );

            if (startIndex === -1) {
              startIndex = this.allAvailableBooths.findIndex(e =>
                e.BoothNumber.toLowerCase().includes(searchLower)
              );
            }
            this.allAvailableBooths = startIndex !== -1
              ? this.allAvailableBooths.slice(startIndex)
              : [];

            this.allAvailableBooths.forEach(e => {
              e.boothChecked = e.BoothNumber.toLowerCase() === searchLower;

              if (e.boothChecked) {
                this.selectBooth({ srcElement: { checked: true } } as any, e);
              }
            });
            if (this.allAvailableBooths.length == 0) {
              Swal.fire({
                text: $localize`Provided booth does not exists/already has been selected by another user!`,
                icon: "warning",
                confirmButtonText: $localize`Ok`,
              });
              this.allAvailableBooths = response;

              if (excludedBoothNumbers) {
                var excludedBooths = excludedBoothNumbers.split(',');
                excludedBooths.forEach(booth => {
                  this.allAvailableBooths = this.allAvailableBooths.filter(e => e.BoothNumber != booth)
                })
              }
            }
          }
          this.loadHourGlassLoader = Promise.resolve(false);
        }, err => {
          this.loadHourGlassLoader = Promise.resolve(false);
        });
      });
    }
  }

  enableBoothSearch(): boolean {
    return (this.rentalForm.controls['boothSearchScreen'].value['rentalStartDate'] != '' &&
      this.rentalForm.controls['boothSearchScreen'].value['rentalEndDate'] != '' &&
      this.rentalForm.controls['boothSearchScreen'].value['boothParts']);
  }

  getDaysDifference(date1: Date, date2: Date): number {
    // Normalize both dates to start of the day (midnight)
    const start = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    const end = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
    // Calculate the difference in time (milliseconds)
    const timeDiff = Math.abs(end.getTime() - start.getTime());
    // Convert time difference from milliseconds to days
    const dayDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
    return dayDiff;
  }

  selectedMonthlyMarketDays() {
    this.selectedMarketDays = [];
    this.rentalForm.controls['boothSearchScreen'].get('marketDaysSunday')?.value == true ? this.selectedMarketDays.push(1) : 0;
    this.rentalForm.controls['boothSearchScreen'].get('marketDaysMonday')?.value == true ? this.selectedMarketDays.push(2) : 0;
    this.rentalForm.controls['boothSearchScreen'].get('marketDaysTuesday')?.value == true ? this.selectedMarketDays.push(3) : 0;
    this.rentalForm.controls['boothSearchScreen'].get('marketDaysWednesday')?.value == true ? this.selectedMarketDays.push(4) : 0;
    this.rentalForm.controls['boothSearchScreen'].get('marketDaysThursday')?.value == true ? this.selectedMarketDays.push(5) : 0;
    this.rentalForm.controls['boothSearchScreen'].get('marketDaysFriday')?.value == true ? this.selectedMarketDays.push(6) : 0;
    this.rentalForm.controls['boothSearchScreen'].get('marketDaysSaturday')?.value == true ? this.selectedMarketDays.push(7) : 0;
    this.rentalStartDates = [];
    this.selectedMarketDays.map(async (el, i) => {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth();
      const startMonth = this.rentalForm.controls['boothSearchScreen'].value['rentalStartMonth'];
      const endMonth = this.rentalForm.controls['boothSearchScreen'].value['rentalEndMonth'];
      const [startMonthDate, startYear] = startMonth.split(' ');
      const [endMonthDate, endMonthYear] = endMonth.split(' ');
      const startMonthIndex = this.getMonthIndex(startMonthDate);
      const endMonthIndex = this.getMonthIndex(endMonthDate);
      var startDate;
      if (startYear === currentYear.toString() && startMonthIndex === currentMonth)
        startDate = currentDate
      else
        startDate = new Date(startYear, startMonthIndex, 1);
      var endDate = new Date(endMonthYear, endMonthIndex + 1, 0);
      const selectedDayOfWeek = el - 1;
      let currentDay = new Date(startDate);
      while (new Date(this.datePipe.transform(currentDay, 'MM/dd/yyyy')) <= new Date(this.datePipe.transform(endDate, 'MM/dd/yyyy'))) {
        if (currentDay.getDay() === selectedDayOfWeek) {
          this.rentalStartDates.push({ startDate: this.datePipe.transform(new Date(currentDay), 'MMM d, y') });
        }
        currentDay.setDate(currentDay.getDate() + 1);
      }
      const compareDates = (a: DateString, b: DateString): number => {
        const dateA = new Date(a.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
        const dateB = new Date(b.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
        return dateA - dateB;
      };
      const sortedDates = this.rentalStartDates.sort(compareDates);
      if (this.rentalStartDates && this.rentalStartDates.length > 0)
        this.rentalForm.controls['boothSearchScreen'].get('rentalStartDates1').setValue(this.rentalStartDates[0].startDate)
    });
  }

  hideOtherChargeModel() {
    this.closeModalById('modalAddOtherRentals');
  }

  updateOtherItem(data) {
    // Set quantity to 1 only if it is empty or zero.
    if (
      data.Quantity === '' ||
      data.Quantity === null ||
      data.Quantity === undefined ||
      Number(data.Quantity) === 0
    ) {
      data.Quantity = "1";
    }

    this.totalSalesTax -= this.getActualAmountFromInp(data.SalesTax);
    this.totalSecondLeveltax -= this.getActualAmountFromInp(data.CityTax);
    var priorBalance = this.getActualAmountFromInp(this.rentalForm.controls['vendorBalances'].value['vendorPriorBalance']);
    this.totalOtherRentalCharge -= this.getActualAmountFromInp(data.OtherItemtotal);
    this.totalCharge = priorBalance + this.totalRentalCharge + this.totalOtherRentalCharge + this.totalSalesTax + this.totalSecondLeveltax;

    var index;
    if (data.NewItem == true)
      index = this.selectedOtherItems.findIndex(oth => oth.Id === data.Id && oth.RentalMonth == data.RentalMonth && oth.NewItem == true && oth.BoothNo == data.BoothNo);
    else
      index = this.selectedOtherItems.findIndex(oth => oth.Id === data.Id && oth.RentalMonth == data.RentalMonth && oth.MonthlyRentalIds == data.MonthlyRentalIds && oth.BoothNo == data.BoothNo);

    if (index !== -1) {
      var obj = {
        OtherItemId: data.Id,
        VendorId: this.vendorId,
        Quantity: data.Quantity,
        OtherItemCharge: this.getActualAmountFromInp(data.OtherItemCharge)
      }
      this.operationRentalService.getOtherItemsRentalCharges(obj).subscribe((res: any) => {
        this.selectedOtherItems[index].SalesTax = this.customCurrency.transform(res.SalesTax.toString()),
          this.selectedOtherItems[index].CityTax = this.customCurrency.transform(res.CityTax.toString())
        const isNegative = data.OtherItemCharge.includes('(') && data.OtherItemCharge.includes(')');
        const totalValue = data.OtherItemCharge == "" ? 0 : parseFloat(data.OtherItemCharge.replace(/[^0-9.-]/g, ''));
        const finalCharge = isNegative ? -totalValue : totalValue;
        data.OtherItemtotal = this.customCurrency.transform((finalCharge * data.Quantity).toString());
        this.selectedOtherItems[index].OtherItemtotal = data.OtherItemtotal;
        this.selectedOtherItems[index].OtherItemCharge = this.customCurrency.transform((finalCharge).toString());
        this.selectedOtherItems[index].Recurring = data.Recurring;
        this.selectedOtherItems[index].Reference = data.Reference;
        this.selectedOtherItems[index].Quantity = data.Quantity;
        this.selectedOtherItems[index].SalesTax = this.customCurrency.transform(res.SalesTax.toString()),
          this.selectedOtherItems[index].CityTax = this.customCurrency.transform(res.CityTax.toString()),
          this.gridOtherRental.refresh();
        this.disableSave = false;
        this.isFormDirty.emit(true);
        this.totalOtherRentalCharge += this.getActualAmountFromInp(data.OtherItemtotal);
        this.totalSalesTax += this.getActualAmountFromInp(res.SalesTax);
        this.totalSecondLeveltax += this.getActualAmountFromInp(res.CityTax);
        this.setRentalCharges();
      });
    }
  }

  disableOtherCharge() {
    if (this.selectedOtherCharges.length > 0)
      return false;
    else
      return true;
  }

  addOtherCharges() {
    this.hideOtherChargeModel();
    if (this.selectedOtherCharges) {
      this.loaderIcon = Promise.resolve(true);
      this.selectedOtherCharges.map((el, i) => {
        var obj = {
          OtherItemId: el.Id,
          VendorId: this.vendorId,
          Quantity: el.Quantity,
          OtherItemCharge: this.getActualAmountFromInp(el.OtherItemCharge)
        }
        const index = this.selectedOtherItems.findIndex(item => item.Id === el.Id && item.RentalMonth == this.rentalForm.controls['otherItemsScreen'].value['otherChargeMarketMonth'] && item.NewItem == true && item.BoothNo === el.othChgBooths);
        this.operationRentalService.getOtherItemsRentalCharges(obj).subscribe((res: any) => {
          var newItem = [];
          if (index !== -1) {
            var otherItemTotal = this.selectedOtherItems[index].OtherItemtotal;
            var salesTax = this.selectedOtherItems[index].SalesTax;
            var cityTax = this.selectedOtherItems[index].CityTax;
            this.totalOtherRentalCharge -= this.getActualAmountFromInp(otherItemTotal);
            this.totalSalesTax -= this.getActualAmountFromInp(salesTax);
            this.totalSecondLeveltax -= this.getActualAmountFromInp(cityTax);
            this.setRentalCharges();
            const ob = {
              Id: el.Id,
              MonthOtherRentalId: 0,
              OtherItem: el.OtherItem,
              Quantity: el.Quantity,
              OtherItemtotal: el.OtherItemtotal,
              OtherItemCharge: el.OtherItemCharge,
              RentalMonth: el.RentalMonth,
              SalesTax: this.customCurrency.transform(res.SalesTax.toString()),
              CityTax: this.customCurrency.transform(res.CityTax.toString()),
              BoothNo: el.othChgBooths,
              Recurring: el.Recurring,
              Reference: el.Reference?.trim(),
              NewItem: true,
              MonthlyRentalIds: ''
            }
            this.selectedOtherItems[index] = ob;
            this.gridOtherRental.refresh();
          }
          else {
            const ob = {
              Id: el.Id,
              MonthOtherRentalId: 0,
              OtherItem: el.OtherItem,
              OtherItemCharge: el.OtherItemCharge,
              Quantity: el.Quantity,
              OtherItemtotal: el.OtherItemtotal,
              RentalMonth: el.RentalMonth,
              SalesTax: this.customCurrency.transform(res.SalesTax.toString()),
              CityTax: this.customCurrency.transform(res.CityTax.toString()),
              BoothNo: el.othChgBooths,
              Recurring: el.Recurring,
              Reference: el.Reference?.trim(),
              NewItem: true,
              MonthlyRentalIds: ''
            }
            newItem.push(JSON.parse(JSON.stringify(ob)));
          }
          this.totalOtherRentalCharge += this.getActualAmountFromInp(el.OtherItemtotal);
          this.totalSalesTax += this.getActualAmountFromInp(res.SalesTax);
          this.totalSecondLeveltax += this.getActualAmountFromInp(res.CityTax);
          this.setRentalCharges();

          if (newItem.length > 0) {
            this.selectedOtherItems = this.selectedOtherItems.concat(newItem);
          }
          this.disableSave = false;
          this.isFormDirty.emit(true);
        }, err => {
          this.loaderIcon = Promise.resolve(false);
        });
      });

      this.loaderIcon = Promise.resolve(false);
      this.closeModalById('modalAddOtherRentals');
    }
  }

  resetRentMonthsInGrid(res) {
    res.JanuaryMonthPresent ? this.gridMonthlyRental.getColumnByField("January").visible = true : null;
    res.FebruaryMonthPresent ? this.gridMonthlyRental.getColumnByField("February").visible = true : null;
    res.MarchMonthPresent ? this.gridMonthlyRental.getColumnByField("March").visible = true : null;
    res.AprilMonthPresent ? this.gridMonthlyRental.getColumnByField("April").visible = true : null;
    res.MayMonthPresent ? this.gridMonthlyRental.getColumnByField("May").visible = true : null;
    res.JuneMonthPresent ? this.gridMonthlyRental.getColumnByField("June").visible = true : null;
    res.JulyMonthPresent ? this.gridMonthlyRental.getColumnByField("July").visible = true : null;
    res.AugustMonthPresent ? this.gridMonthlyRental.getColumnByField("August").visible = true : null;
    res.SeptemberMonthPresent ? this.gridMonthlyRental.getColumnByField("September").visible = true : null;
    res.OctoberMonthPresent ? this.gridMonthlyRental.getColumnByField("October").visible = true : null;
    res.NovemberMonthPresent ? this.gridMonthlyRental.getColumnByField("November").visible = true : null;
    res.DecemberMonthPresent ? this.gridMonthlyRental.getColumnByField("December").visible = true : null;
    setTimeout(() => {
      this.gridMonthlyRental?.refresh();
    });
  }

  addSelectedBoothsToGrid() {
    this.selectedBoothsForRental = [];
    if (this.selectedMonthlyBoothData) {
      this.loaderIcon = Promise.resolve(true);
      this.selectedMonthlyBoothData.map(async (el, i) => {
        const endMonth = this.rentalForm.controls['boothSearchScreen'].value['rentalEndMonth'];
        const [endMonthDate, endMonthYear] = endMonth.split(' ');
        const endMonthIndex = this.getMonthIndex(endMonthDate);
        var endDate = new Date(endMonthYear, endMonthIndex + 1, 0);

        var obj = {
          BoothTypeId: el.BoothTypeId,
          VendorId: this.vendorId,
          RentalStartPeriod: new Date(this.rentalForm.controls['boothSearchScreen'].value['rentalStartDates1']),
          RentalEndPeriod: endDate
        }

        this.operationRentalService.getBoothRentalCombinedMonthlyCharges(obj).subscribe((res: any) => {
          var newbooths = [];
          this.resetRentMonthsInGrid(res);
          var vendorProducts = this.vendorProducts.filter(x => x.Priority) ? this.vendorProducts.filter(x => x.Priority)[0].ProductId : this.vendorProducts[0].ProductId;
          const ob = {
            MonthlyRentalId: 0,
            BoothNumber: el.BoothNumber,
            BoothType: el.BoothType,
            BoothTypeId: el.BoothTypeId,
            Product: vendorProducts,
            RentStartPeriod: this.rentalForm.controls['boothSearchScreen'].value['rentalStartMonth'],
            RentEndPeriod: this.rentalForm.controls['boothSearchScreen'].value['rentalEndMonth'],
            RentalStartDate: el.RentalStartDate,
            RentalEndDate: el.RentalEndDate,
            RentalSavedEndDate: el.RentalEndDate,
            MktDays: el.NoOfMarketDays,
            PerDiem: false,
            PerDiemRent: this.customCurrency.transform(res.PerdiemRent),
            Rent: this.customCurrency.transform(res.Rent),
            SalesTax: this.customCurrency.transform(res.SalesTax),
            CityTax: this.customCurrency.transform(res.CityTax),
            Sunday: el.Sunday,
            Monday: el.Monday,
            Tuesday: el.Tuesday,
            Wednesday: el.Wednesday,
            Thursday: el.Thursday,
            Friday: el.Friday,
            Saturday: el.Saturday,
            Reservation: true,
            Drop: false,
            January: this.customCurrency.transform(res.JanRent),
            February: this.customCurrency.transform(res.FebRent),
            March: this.customCurrency.transform(res.MarRent),
            April: this.customCurrency.transform(res.AprRent),
            May: this.customCurrency.transform(res.MayRent),
            June: this.customCurrency.transform(res.JunRent),
            July: this.customCurrency.transform(res.JulRent),
            August: this.customCurrency.transform(res.AugRent),
            September: this.customCurrency.transform(res.SepRent),
            October: this.customCurrency.transform(res.OctRent),
            November: this.customCurrency.transform(res.NovRent),
            December: this.customCurrency.transform(res.DecRent),
            JanuaryMonthPresent: res.JanuaryMonthPresent,
            FebruaryMonthPresent: res.FebruaryMonthPresent,
            MarchMonthPresent: res.MarchMonthPresent,
            AprilMonthPresent: res.AprilMonthPresent,
            MayMonthPresent: res.MayMonthPresent,
            JuneMonthPresent: res.JuneMonthPresent,
            JulyMonthPresent: res.JulyMonthPresent,
            AugustMonthPresent: res.AugustMonthPresent,
            SeptemberMonthPresent: res.SeptemberMonthPresent,
            OctoberMonthPresent: res.OctoberMonthPresent,
            NovemberMonthPresent: res.NovemberMonthPresent,
            DecemberMonthPresent: res.DecemberMonthPresent,
            DisableJanMonth: res.JanRent != null ? false : true,
            DisableFebMonth: res.FebRent != null ? false : true,
            DisableMarMonth: res.MarRent != null ? false : true,
            DisableAprMonth: res.AprRent != null ? false : true,
            DisableMayMonth: res.MayRent != null ? false : true,
            DisableJunMonth: res.JunRent != null ? false : true,
            DisableJulMonth: res.JulRent != null ? false : true,
            DisableAugMonth: res.AugRent != null ? false : true,
            DisableSepMonth: res.SepRent != null ? false : true,
            DisableOctMonth: res.OctRent != null ? false : true,
            DisableNovMonth: res.NovRent != null ? false : true,
            DisableDecMonth: res.DecRent != null ? false : true,
            Status: "N",
            StartDateList: el.StartDateList,
            DiasbleStartDate: false,
            NewBooth: true,
            ExtendRental: false,
            AllRentalDates: el.AllRentalDates,
            TaxModel: res.TaxModel
          }

          this.totalRentalCharge += this.getActualAmountFromInp(res.Rent);
          this.totalSalesTax += this.getActualAmountFromInp(res.SalesTax);
          this.totalSecondLeveltax += this.getActualAmountFromInp(res.CityTax);
          this.setRentalCharges()

          this.gridMonthlyRental.refresh();
          newbooths.push(JSON.parse(JSON.stringify(ob)));
          this.selectedMonthlyBooths = this.selectedMonthlyBooths.concat(newbooths);
          this.disableSave = false;
          this.isFormDirty.emit(true);
        }, err => {
          this.loaderIcon = Promise.resolve(false);
        });
      });

      this.loaderIcon = Promise.resolve(false);
      this.closeModalById('modalAddNewMonthlyBooths');
      //  this.refreshAddBooth();
    }
  }

  getValidAmount(value: any): number {
    return value != null && value.toString().trim() !== '' ? value : 0;
  }

  setRentalCharges() {
    var priorBalance = this.getActualAmountFromInp(this.rentalForm.controls['vendorBalances'].value['vendorPriorBalance']);
    this.totalCharge = priorBalance + this.totalRentalCharge + this.totalOtherRentalCharge + this.totalSalesTax + this.totalSecondLeveltax;
    this.rentalForm.controls['vendorBalances'].patchValue({
      totalRentalCharge: this.customCurrency.transform(this.totalRentalCharge.toString()),
      totalOtherRentalCharge: this.customCurrency.transform(this.totalOtherRentalCharge.toString()),
      totalSalesTax: this.customCurrency.transform(this.totalSalesTax.toString()),
      totalSecondLeveltax: this.customCurrency.transform(this.totalSecondLeveltax.toString()),
      totalCharge: this.customCurrency.transform(this.totalCharge.toString())
    });
  }

  isFormatted(value: string | number): boolean {
    // Convert to string if it's a number, then check if it contains any currency symbols or formatted structure.
    return typeof value === 'string' && /[\$£€₹,]/.test(value); // Adjust the regex as needed for your currency format
  }

  async updateBoothData(data) {
    var index = this.selectedMonthlyBooths.findIndex(e => e.RentStartPeriod == data.RentStartPeriod && e.RentEndPeriod == data.RentEndPeriod
      && e.BoothNumber == data.BoothNumber)
    if (index !== -1) {
      var totalRent = 0;
      this.totalRentalCharge -= this.getActualAmountFromInp(data.Rent ?? 0);
      this.totalSalesTax -= this.getActualAmountFromInp(data.SalesTax ?? 0);
      this.totalSecondLeveltax -= this.getActualAmountFromInp(data.CityTax ?? 0);
      this.setRentalCharges();
      totalRent += data.January ? this.getActualAmountFromInp(data.January) : 0;
      totalRent += data.February ? this.getActualAmountFromInp(data.February) : 0;
      totalRent += data.March ? this.getActualAmountFromInp(data.March) : 0;
      totalRent += data.April ? this.getActualAmountFromInp(data.April) : 0;
      totalRent += data.May ? this.getActualAmountFromInp(data.May) : 0;
      totalRent += data.June ? this.getActualAmountFromInp(data.June) : 0;
      totalRent += data.July ? this.getActualAmountFromInp(data.July) : 0;
      totalRent += data.August ? this.getActualAmountFromInp(data.August) : 0;
      totalRent += data.September ? this.getActualAmountFromInp(data.September) : 0;
      totalRent += data.October ? this.getActualAmountFromInp(data.October) : 0;
      totalRent += data.November ? this.getActualAmountFromInp(data.November) : 0;
      totalRent += data.December ? this.getActualAmountFromInp(data.December) : 0;

      var JanRentAmount = this.getValidAmount(data.January);
      var FebRentAmount = this.getValidAmount(data.February);
      var MarRentAmount = this.getValidAmount(data.March);
      var AprRentAmount = this.getValidAmount(data.April);
      var MayRentAmount = this.getValidAmount(data.May);
      var JunRentAmount = this.getValidAmount(data.June);
      var JulRentAmount = this.getValidAmount(data.July);
      var AugRentAmount = this.getValidAmount(data.August);
      var SepRentAmount = this.getValidAmount(data.September);
      var OctRentAmount = this.getValidAmount(data.October);
      var NovRentAmount = this.getValidAmount(data.November);
      var DecRentAmount = this.getValidAmount(data.December);

      var extendRentalStartPeriod;
      if (!this.selectedMonthlyBooths[index].NewBooth && this.selectedMonthlyBooths[index].Status != "R") {
        extendRentalStartPeriod = new Date(this.selectedMonthlyBooths[index].RentalSavedEndDate);
        if (extendRentalStartPeriod.getDate() == 31) {
          extendRentalStartPeriod.setDate(extendRentalStartPeriod.getDate() + 1);
        }
        else {
          extendRentalStartPeriod.setMonth(extendRentalStartPeriod.getMonth() + 1);
        }
        extendRentalStartPeriod.setDate(1);
      }
      else {
        extendRentalStartPeriod = this.selectedMonthlyBooths[index].RentalStartDate;
      }

      var obj = {
        BoothTypeId: this.selectedMonthlyBooths[index].BoothTypeId,
        VendorId: this.vendorId,
        RentalStartPeriod: new Date(extendRentalStartPeriod),
        RentalEndPeriod: new Date(this.selectedMonthlyBooths[index].RentalEndDate),
        PerDiemApplicable: data.PerDiem,
        overrideRentCharge: true,
        JanRent: this.getActualAmountFromInp(JanRentAmount),
        FebRent: this.getActualAmountFromInp(FebRentAmount),
        MarRent: this.getActualAmountFromInp(MarRentAmount),
        AprRent: this.getActualAmountFromInp(AprRentAmount),
        MayRent: this.getActualAmountFromInp(MayRentAmount),
        JunRent: this.getActualAmountFromInp(JunRentAmount),
        JulRent: this.getActualAmountFromInp(JulRentAmount),
        AugRent: this.getActualAmountFromInp(AugRentAmount),
        SepRent: this.getActualAmountFromInp(SepRentAmount),
        OctRent: this.getActualAmountFromInp(OctRentAmount),
        NovRent: this.getActualAmountFromInp(NovRentAmount),
        DecRent: this.getActualAmountFromInp(DecRentAmount)
      }

      var res = await lastValueFrom(this.operationRentalService.getBoothRentalCombinedMonthlyCharges(obj));
      if (res) {
        this.selectedMonthlyBooths[index].Rent = this.customCurrency.transform(res.Rent);
        this.selectedMonthlyBooths[index].SalesTax = this.customCurrency.transform(res.SalesTax);
        this.selectedMonthlyBooths[index].CityTax = this.customCurrency.transform(res.CityTax);
        this.selectedMonthlyBooths[index].Reservation = data.Reservation;
        this.selectedMonthlyBooths[index].Drop = data.Drop;
        this.selectedMonthlyBooths[index].January = this.isFormatted(data.January) ? data.January : this.customCurrency.transform(data.January == "" ? 0 : data.January);
        this.selectedMonthlyBooths[index].February = this.isFormatted(data.February) ? data.February : this.customCurrency.transform(data.February == "" ? 0 : data.February);
        this.selectedMonthlyBooths[index].March = this.isFormatted(data.March) ? data.March : this.customCurrency.transform(data.March == "" ? 0 : data.March);
        this.selectedMonthlyBooths[index].April = this.isFormatted(data.April) ? data.April : this.customCurrency.transform(data.April == "" ? 0 : data.April);
        this.selectedMonthlyBooths[index].May = this.isFormatted(data.May) ? data.May : this.customCurrency.transform(data.May == "" ? 0 : data.May);
        this.selectedMonthlyBooths[index].June = this.isFormatted(data.June) ? data.June : this.customCurrency.transform(data.June == "" ? 0 : data.June);
        this.selectedMonthlyBooths[index].July = this.isFormatted(data.July) ? data.July : this.customCurrency.transform(data.July == "" ? 0 : data.July);
        this.selectedMonthlyBooths[index].August = this.isFormatted(data.August) ? data.August : this.customCurrency.transform(data.August == "" ? 0 : data.August);
        this.selectedMonthlyBooths[index].September = this.isFormatted(data.September) ? data.September : this.customCurrency.transform(data.September == "" ? 0 : data.September);
        this.selectedMonthlyBooths[index].October = this.isFormatted(data.October) ? data.October : this.customCurrency.transform(data.October == "" ? 0 : data.October);
        this.selectedMonthlyBooths[index].November = this.isFormatted(data.November) ? data.November : this.customCurrency.transform(data.November == "" ? 0 : data.November);
        this.selectedMonthlyBooths[index].December = this.isFormatted(data.December) ? data.December : this.customCurrency.transform(data.December == "" ? 0 : data.December);
        this.selectedMonthlyBooths[index].RentalStartDate = data.RentalStartDate;
        this.selectedMonthlyBooths[index].RentalEndDate = data.RentalEndDate;
        this.selectedMonthlyBooths[index].PerDiem = data.PerDiem;
        this.selectedMonthlyBooths[index].PerDiemRent = this.customCurrency.transform(res.PerdiemRent);
        this.selectedMonthlyBooths[index].TaxModel = res.TaxModel;
        this.totalRentalCharge += this.getActualAmountFromInp(res.Rent);
        this.totalSalesTax += this.getActualAmountFromInp(res.SalesTax);
        this.totalSecondLeveltax += this.getActualAmountFromInp(res.CityTax);
        this.setRentalCharges();
        this.gridMonthlyRental.refresh();
        this.disableSave = false;
        this.isFormDirty.emit(true);
      }
    }
  }

  refreshAddBooth() {
    this.getMarketDaysSettings();
    this.selectedMonthlyBoothData = [];
    this.allAvailableBooths = [];
    this.isMonthlyboothSelected = true;
    if (this.selectedBoothsForRental.length > 0) {
      this.selectedBoothsForRental.forEach(ele => {
        const temp = {
          TempRecordNo: this.tempRecordNo.toString(),
          BoothNo: ele.BoothNumber,
          StartDate: new Date(ele.StartDate),
          RentalType: 4,
          EndDate: new Date(ele.EndDate),
          Sunday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysSunday')?.value ?? false,
          Monday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysMonday')?.value ?? false,
          Tuesday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysTuesday')?.value ?? false,
          Wednesday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysWednesday')?.value ?? false,
          Thursday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysThursday')?.value ?? false,
          Friday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysFriday')?.value ?? false,
          Saturday: this.rentalForm.controls['boothSearchScreen'].get('marketDaysSaturday')?.value ?? false
        }
        this.subscriptions.push(
          this.operationRentalService.deleteFromTemp(temp).subscribe((res: any) => {
          })
        );
      });
    }
    this.selectedBoothsForRental = [];
    this.rentalForm.controls['boothSearchScreen'].reset();
    this.rentalForm.controls['boothSearchScreen'].patchValue({
      rentalStartMonth: this.monthlyMarketDays[0].RentalMonths,
      rentalEndMonth: this.monthlyMarketDays[0].RentalMonths,
      srcBoothNumber: "",
      boothParts: !this.displayDefaultPart ? (this.displayLayoutPopup ? this.parts[0].PartId : '0') : this.defaultPartId
    })
  }

  getActualAmountFromInp(value: any): number {
    if (value == null) return 0;
    try {
      const valStr = value.toString();
      if (valStr.includes('(') && valStr.includes(')')) {
        return -1 * parseFloat(valStr.replace(/[^0-9.-]/g, ''));
      } else {
        return parseFloat(valStr.replace(/[^0-9.-]/g, ''));
      }
    } catch (err) {
      console.warn('Error in getActualAmountFromInp:', value, err);
      return 0;
    }
  }

  updateInput() {
    const inputs = document.querySelectorAll<HTMLInputElement>('input[data-auto-blur]');
    inputs.forEach((input) => input.blur());
  }

  created(args) {
    if (this.selectedMonthlyBooths) {
      this.hideMonthCoulmnsInBoothGrid();
      this.selectedMonthlyBooths.map((el, i) => {
        if (el.NewBooth) {
          this.resetRentMonthsInGrid(el);
          this.gridMonthlyRental.refresh();
        }
      });
    }
  }

  Payment() {
    this.payByBooth = true;
    this.openModalById('payByBoothModal');
    this.hideTopHeaders.emit(true);
  }

  closeRentalExtendPopup() {
    this.closeModalById('rentalExtensionModal');
  }

  disablePayBooth() {
    var rentalPresent = this.totalRentalCharge + this.totalOtherRentalCharge;
    if (rentalPresent != 0) {
      return false;
    }
    return true;
  }

  extendRental() {
    const extendedRentalEndDates = this.rentalForm.controls['RentalExtensionForm'].value['rentalEndMonth']
    Swal.fire({
      title: $localize`Confirm`,
      text: $localize`Are you sure you wish to extend the bookings till ` + extendedRentalEndDates + '? Please note that the extended period cannot be cancelled',
      icon: "question",
      showCancelButton: true,
      confirmButtonText: $localize`Yes`,
      cancelButtonText: $localize`No`,
    }).then((result) => {
      if (result.value) {
        if (this.extendRentalRecord) {
          this.extendingBooth = true;
          this.proceedExtendingRental();
        }
      }
    });
  }

  async proceedExtendingRental() {
    if (this.extendRentalRecord.MonthlyRentalId != 0)
      var recordExist = this.selectedMonthlyBooths.findIndex(e => e.RentStartPeriod == this.extendRentalRecord.RentStartPeriod && e.RentEndPeriod == this.extendRentalRecord.RentEndPeriod
        && e.BoothNumber == this.extendRentalRecord.BoothNumber && e.MonthlyRentalId == this.extendRentalRecord.MonthlyRentalId);
    else
      var recordExist = this.selectedMonthlyBooths.findIndex(e => e.RentStartPeriod == this.extendRentalRecord.RentStartPeriod && e.RentEndPeriod == this.extendRentalRecord.RentEndPeriod
        && e.BoothNumber == this.extendRentalRecord.BoothNumber && e.RentalMarketDay == this.extendRentalRecord.RentalMarketDay);

    if (recordExist != -1) {
      const rentalDates = [];
      var currentMonthRentalDates = [];
      var rentalstartDate;
      var marketDays = 0;
      for (const el of this.marketDaysEnabled) {
        const selectedDayOfWeek = el;
        var startDate = new Date(this.selectedMonthlyBooths[recordExist].RentalStartDate);
        const endMonth = this.rentalForm.controls['RentalExtensionForm'].value['rentalEndMonth'];
        const [endMonthDate, endMonthYear] = endMonth.split(' ');
        const endMonthIndex = this.getMonthIndex(endMonthDate);
        var endDate = new Date(endMonthYear, endMonthIndex + 1, 0);

        var lastRentalEndDate = this.selectedMonthlyBooths[recordExist].RentalSavedEndDate
        let currentDay = new Date(startDate);
        while (currentDay <= endDate) {
          if (currentDay.getDay() === selectedDayOfWeek) {
            if (!rentalstartDate) {
              rentalstartDate = this.datePipe.transform(new Date(currentDay), 'MMM d, y');
            }
            if (!this.selectedMonthlyBooths[recordExist].NewBooth) {
              if (new Date(currentDay) > new Date(lastRentalEndDate)) {
                marketDays += 1;
              }
            }
            else { marketDays += 1; }

            rentalDates.push({ startDate: this.datePipe.transform(new Date(currentDay), 'MMM d, y') });
          }
          currentDay.setDate(currentDay.getDate() + 1);
        }
      }

      const compareDates = (a: DateString, b: DateString): number => {
        const dateA = new Date(a.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
        const dateB = new Date(b.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
        return dateA - dateB;
      };
      const sortedDates = rentalDates.sort(compareDates);

      currentMonthRentalDates = rentalDates;

      var RentAmount = this.selectedMonthlyBooths[recordExist].Rent;
      var SalesTax = this.selectedMonthlyBooths[recordExist].SalesTax;
      var CityTax = this.selectedMonthlyBooths[recordExist].CityTax;
      var JanRentAmount = this.selectedMonthlyBooths[recordExist].January ?? 0;
      var FebRentAmount = this.selectedMonthlyBooths[recordExist].February ?? 0;
      var MarRentAmount = this.selectedMonthlyBooths[recordExist].March ?? 0;
      var AprRentAmount = this.selectedMonthlyBooths[recordExist].April ?? 0;
      var MayRentAmount = this.selectedMonthlyBooths[recordExist].May ?? 0;
      var JunRentAmount = this.selectedMonthlyBooths[recordExist].June ?? 0;
      var JulRentAmount = this.selectedMonthlyBooths[recordExist].July ?? 0;
      var AugRentAmount = this.selectedMonthlyBooths[recordExist].August ?? 0;
      var SepRentAmount = this.selectedMonthlyBooths[recordExist].September ?? 0;
      var OctRentAmount = this.selectedMonthlyBooths[recordExist].October ?? 0;
      var NovRentAmount = this.selectedMonthlyBooths[recordExist].November ?? 0;
      var DecRentAmount = this.selectedMonthlyBooths[recordExist].December ?? 0;
      this.totalRentalCharge -= this.getActualAmountFromInp(RentAmount);
      this.totalSalesTax -= this.getActualAmountFromInp(SalesTax);
      this.totalSecondLeveltax -= this.getActualAmountFromInp(CityTax);
      this.setRentalCharges();

      var extendRentalStartPeriod;
      if (!this.selectedMonthlyBooths[recordExist].NewBooth && this.selectedMonthlyBooths[recordExist].Status != "R") {
        extendRentalStartPeriod = new Date(this.selectedMonthlyBooths[recordExist].RentalSavedEndDate);
        if (extendRentalStartPeriod.getDate() == 31) {
          extendRentalStartPeriod.setDate(extendRentalStartPeriod.getDate() + 1);
        }
        else {
          extendRentalStartPeriod.setMonth(extendRentalStartPeriod.getMonth() + 1);
        }
        extendRentalStartPeriod.setDate(1);
      }
      else {
        extendRentalStartPeriod = this.selectedMonthlyBooths[recordExist].RentalStartDate;
      }
      var obj = {
        BoothTypeId: this.selectedMonthlyBooths[recordExist].BoothTypeId,
        VendorId: this.vendorId,
        RentalStartPeriod: new Date(extendRentalStartPeriod),
        RentalEndPeriod: new Date(rentalDates[rentalDates.length - 1].startDate),
        PerDiemApplicable: this.selectedMonthlyBooths[recordExist].PerDiem,
        JanRent: this.getActualAmountFromInp(JanRentAmount),
        FebRent: this.getActualAmountFromInp(FebRentAmount),
        MarRent: this.getActualAmountFromInp(MarRentAmount),
        AprRent: this.getActualAmountFromInp(AprRentAmount),
        MayRent: this.getActualAmountFromInp(MayRentAmount),
        JunRent: this.getActualAmountFromInp(JunRentAmount),
        JulRent: this.getActualAmountFromInp(JulRentAmount),
        AugRent: this.getActualAmountFromInp(AugRentAmount),
        SepRent: this.getActualAmountFromInp(SepRentAmount),
        OctRent: this.getActualAmountFromInp(OctRentAmount),
        NovRent: this.getActualAmountFromInp(NovRentAmount),
        DecRent: this.getActualAmountFromInp(DecRentAmount)
      }

      this.subscriptions.push(this.operationRentalService.getBoothRentalCombinedMonthlyCharges(obj).subscribe((res: any) => {
        this.resetRentMonthsInGrid(res);
        const booth = this.selectedMonthlyBooths[recordExist];
        const rentalEndMonth = this.rentalForm.controls['RentalExtensionForm'].value['rentalEndMonth'];
        this.updateMonthlyBoothData(booth, res, rentalDates, marketDays, currentMonthRentalDates, rentalEndMonth);
        this.totalRentalCharge += this.getActualAmountFromInp(res.Rent);
        this.totalSalesTax += this.getActualAmountFromInp(res.SalesTax);
        this.totalSecondLeveltax += this.getActualAmountFromInp(res.CityTax);

        this.setRentalCharges();
        this.disableSave = false;
        this.isFormDirty.emit(true);
        this.gridMonthlyRental.refresh();
      }, err => {
      }));
      this.closeModalById('rentalExtensionModal');
    }
  }

  async rentalExtension(data) {
    this.renewAllBoothsFromGrid = false;
    this.extendingBooth = false;
    if (!data.Drop && data.Reservation) {
      this.rentEndPeriodIndex = this.monthlyMarketDays.findIndex(e => e.RentalMonths == data.RentEndPeriod);

      // No current rental period or already at maximum month
      if (
        this.rentEndPeriodIndex === -1 ||
        this.rentEndPeriodIndex >= this.monthlyMarketDays.length - 1
      ) {
        Swal.fire({
          title: $localize`Warning`,
          text: $localize`Rental End Period cannot be extended further`,
          icon: "warning",
          confirmButtonText: $localize`Ok`,
        });

        return;
      }

      this.rentalForm.controls['RentalExtensionForm'].get('rentalEndMonth').setValue(this.monthlyMarketDays[this.rentEndPeriodIndex + 1].RentalMonths)
      this.extendRentalRecord = data;
      this.BoothNumber = data.BoothNumber;
      data.Sunday ? this.rentalForm.controls['RentalExtensionForm'].get('marketDaysSunday').enable() : this.rentalForm.controls['boothSearchScreen'].get('marketDaysSunday').disable();
      data.Monday ? this.rentalForm.controls['RentalExtensionForm'].get('marketDaysMonday').enable() : this.rentalForm.controls['boothSearchScreen'].get('marketDaysMonday').disable();
      data.Tuesday ? this.rentalForm.controls['RentalExtensionForm'].get('marketDaysTuesday').enable() : this.rentalForm.controls['boothSearchScreen'].get('marketDaysTuesday').disable();
      data.Wednesday ? this.rentalForm.controls['RentalExtensionForm'].get('marketDaysWednesday').enable() : this.rentalForm.controls['boothSearchScreen'].get('marketDaysWednesday').disable();
      data.Thursday ? this.rentalForm.controls['RentalExtensionForm'].get('marketDaysThursday').enable() : this.rentalForm.controls['boothSearchScreen'].get('marketDaysThursday').disable();
      data.Friday ? this.rentalForm.controls['RentalExtensionForm'].get('marketDaysFriday').enable() : this.rentalForm.controls['boothSearchScreen'].get('marketDaysFriday').disable();
      data.Saturday ? this.rentalForm.controls['RentalExtensionForm'].get('marketDaysSaturday').enable() : this.rentalForm.controls['boothSearchScreen'].get('marketDaysSaturday').disable();

      this.rentalForm.controls['RentalExtensionForm'].get('marketDaysSunday').setValue(data.Sunday);
      this.rentalForm.controls['RentalExtensionForm'].get('marketDaysMonday').setValue(data.Monday);
      this.rentalForm.controls['RentalExtensionForm'].get('marketDaysTuesday').setValue(data.Tuesday);
      this.rentalForm.controls['RentalExtensionForm'].get('marketDaysWednesday').setValue(data.Wednesday);
      this.rentalForm.controls['RentalExtensionForm'].get('marketDaysThursday').setValue(data.Thursday);
      this.rentalForm.controls['RentalExtensionForm'].get('marketDaysFriday').setValue(data.Friday);
      this.rentalForm.controls['RentalExtensionForm'].get('marketDaysSaturday').setValue(data.Saturday);

      const extendMonth = this.rentalForm.controls['RentalExtensionForm'].value['rentalEndMonth'];
      const [MonthDate, Year] = extendMonth.split(' ');
      const monthIndex = this.getMonthIndex(MonthDate);
      var endDate = new Date(Year, monthIndex + 1, 0);
      const startDate = new Date(Year, monthIndex, 1);
      var selectedDayOfWeek = [];
      data.Sunday == true ? selectedDayOfWeek.push(0) : 0;
      data.Monday == true ? selectedDayOfWeek.push(1) : 0;
      data.Tuesday == true ? selectedDayOfWeek.push(2) : 0;
      data.Wednesday == true ? selectedDayOfWeek.push(3) : 0;
      data.Thursday == true ? selectedDayOfWeek.push(4) : 0;
      data.Friday == true ? selectedDayOfWeek.push(5) : 0;
      data.Saturday == true ? selectedDayOfWeek.push(6) : 0;

      const rentalDates = [];
      while (startDate <= endDate) {
        selectedDayOfWeek.map((el, i) => {
          var dayOfWeek = el;
          if (startDate.getDay() === dayOfWeek) {
            rentalDates.push(new Date(startDate));
          }
        });
        startDate.setDate(startDate.getDate() + 1);
      }

      var obj = {
        RentalDates: rentalDates,
        BoothNumber: data.BoothNumber
      }

      this.subscriptions.push(this.operationRentalService.checkRentalExits(obj).subscribe((res) => {
        if (!res) {
          this.openModalById('rentalExtensionModal');
        }
        else {
          Swal.fire({
            title: $localize`Warning`,
            text: $localize`Rental End Period cannot be extended further`,
            icon: "warning",
            confirmButtonText: $localize`Ok`,
          });
        }
      }))
    }
    else {
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Rental End Period cannot be extended further`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
    }
  }

  handleEndDateChange() {
    this.renewAllBoothsFromGrid = false;
    this.extendingBooth = false;

    if (this.selectedMonthlyBooths.length > 0) {
      const selectedEndDate = new Date(this.selectedEndDates.split('-')[0]);

      const recordExistForRenewing = this.selectedMonthlyBooths.filter(e => {
        const boothEndDate = new Date(e.RentEndPeriod.split('-')[0]);
        return boothEndDate < selectedEndDate && !e.Drop && e.Reservation;
      });

      if (recordExistForRenewing.length > 0) {
        Swal.fire({
          title: $localize`Confirm`,
          text: $localize`Are you sure you wish to extend the bookings till ` + this.selectedEndDates + '?',
          icon: "question",
          showCancelButton: true,
          confirmButtonText: $localize`Yes`,
          cancelButtonText: $localize`No`,
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.renewAllBoothsFromGrid = true;
            this.extendingBooth = false;
            this.renewAllBooths();
            this.renewOtherCharges();
          }
        });
      } else {
        this.renewOtherCharges();
      }
    } else {
      this.renewOtherCharges();
    }
  }

  async renewAllBooths() {
    var nonAvailableBooths = [];
    for (const item of this.selectedMonthlyBooths) {
      if (new Date(item.RentEndPeriod.split('-')[0]) < new Date(this.selectedEndDates.split('-')[0])
        && !item.Drop && item.Reservation) {
        if (item.MonthlyRentalId != 0)
          var recordExist = this.selectedMonthlyBooths.findIndex(e => e.RentStartPeriod == item.RentStartPeriod && e.RentEndPeriod == item.RentEndPeriod
            && e.BoothNumber == item.BoothNumber && e.MonthlyRentalId == item.MonthlyRentalId);
        else
          var recordExist = this.selectedMonthlyBooths.findIndex(e => e.RentStartPeriod == item.RentStartPeriod && e.RentEndPeriod == item.RentEndPeriod
            && e.BoothNumber == item.BoothNumber);

        if (recordExist != -1) {
          const rentalDates = [];
          var currentMonthRentalDates = [];
          var rentalstartDate = "";
          var marketDays = 0;
          for (const el of this.marketDaysEnabled) {
            var startDate = new Date(this.selectedMonthlyBooths[recordExist].RentalStartDate);
            const endMonth = this.selectedEndDates;
            const [endMonthDate, endMonthYear] = endMonth.split(' ');
            const endMonthIndex = this.getMonthIndex(endMonthDate);
            var endDate = new Date(endMonthYear, endMonthIndex + 1, 0);
            const selectedDayOfWeek = el;
            let currentDay = new Date(startDate);
            while (currentDay <= endDate) {
              if (currentDay.getDay() === selectedDayOfWeek) {
                if (!rentalstartDate) {
                  rentalstartDate = this.datePipe.transform(new Date(currentDay), 'MMM d, y');
                }
                var lastRentalEndDate = item.RentalSavedEndDate
                if (!el.NewBooth) {
                  if (new Date(currentDay) > new Date(lastRentalEndDate)) {
                    marketDays += 1;
                  }
                }
                else { marketDays += 1; }
                rentalDates.push({ startDate: this.datePipe.transform(new Date(currentDay), 'MMM d, y') });
              }
              currentDay.setDate(currentDay.getDate() + 1);
            }
          };

          const compareDates = (a: DateString, b: DateString): number => {
            const dateA = new Date(a.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
            const dateB = new Date(b.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
            return dateA - dateB;
          };
          const sortedDates = rentalDates.sort(compareDates);

          currentMonthRentalDates = rentalDates;

          var allRentalDates = rentalDates.map(el => new Date(el.startDate));
          var currentRentedEndDate = new Date(this.selectedMonthlyBooths[recordExist].RentalEndDate);
          const filteredRentalDates = allRentalDates.filter(rentalDate => rentalDate > currentRentedEndDate);
          var obj1 = {
            RentalDates: filteredRentalDates,
            BoothNumber: this.selectedMonthlyBooths[recordExist].BoothNumber
          }

          const rentalExist = await this.operationRentalService.checkRentalExits(obj1).toPromise();
          if (!rentalExist) {
            var RentAmount = this.selectedMonthlyBooths[recordExist].Rent;
            var SalesTax = this.selectedMonthlyBooths[recordExist].SalesTax;
            var CityTax = this.selectedMonthlyBooths[recordExist].CityTax;
            var JanRentAmount = this.selectedMonthlyBooths[recordExist].January ?? 0;
            var FebRentAmount = this.selectedMonthlyBooths[recordExist].February ?? 0;
            var MarRentAmount = this.selectedMonthlyBooths[recordExist].March ?? 0;
            var AprRentAmount = this.selectedMonthlyBooths[recordExist].April ?? 0;
            var MayRentAmount = this.selectedMonthlyBooths[recordExist].May ?? 0;
            var JunRentAmount = this.selectedMonthlyBooths[recordExist].June ?? 0;
            var JulRentAmount = this.selectedMonthlyBooths[recordExist].July ?? 0;
            var AugRentAmount = this.selectedMonthlyBooths[recordExist].August ?? 0;
            var SepRentAmount = this.selectedMonthlyBooths[recordExist].September ?? 0;
            var OctRentAmount = this.selectedMonthlyBooths[recordExist].October ?? 0;
            var NovRentAmount = this.selectedMonthlyBooths[recordExist].November ?? 0;
            var DecRentAmount = this.selectedMonthlyBooths[recordExist].December ?? 0;
            this.totalRentalCharge -= this.getActualAmountFromInp(RentAmount);
            this.totalSalesTax -= this.getActualAmountFromInp(SalesTax);
            this.totalSecondLeveltax -= this.getActualAmountFromInp(CityTax);
            this.setRentalCharges();

            var extendRentalStartPeriod;
            if (!this.selectedMonthlyBooths[recordExist].NewBooth && this.selectedMonthlyBooths[recordExist].Status != "R") {
              extendRentalStartPeriod = new Date(this.selectedMonthlyBooths[recordExist].RentalSavedEndDate);
              if (extendRentalStartPeriod.getDate() == 31) {
                extendRentalStartPeriod.setDate(extendRentalStartPeriod.getDate() + 1);
              }
              else {
                extendRentalStartPeriod.setMonth(extendRentalStartPeriod.getMonth() + 1);
              }
              extendRentalStartPeriod.setDate(1);
            }
            else {
              extendRentalStartPeriod = this.selectedMonthlyBooths[recordExist].RentalStartDate;
            }

            var obj = {
              BoothTypeId: this.selectedMonthlyBooths[recordExist].BoothTypeId,
              VendorId: this.vendorId,
              RentalStartPeriod: new Date(extendRentalStartPeriod),
              RentalEndPeriod: new Date(rentalDates[rentalDates.length - 1].startDate),
              PerDiemApplicable: this.selectedMonthlyBooths[recordExist].PerDiem,
              JanRent: this.getActualAmountFromInp(JanRentAmount),
              FebRent: this.getActualAmountFromInp(FebRentAmount),
              MarRent: this.getActualAmountFromInp(MarRentAmount),
              AprRent: this.getActualAmountFromInp(AprRentAmount),
              MayRent: this.getActualAmountFromInp(MayRentAmount),
              JunRent: this.getActualAmountFromInp(JunRentAmount),
              JulRent: this.getActualAmountFromInp(JulRentAmount),
              AugRent: this.getActualAmountFromInp(AugRentAmount),
              SepRent: this.getActualAmountFromInp(SepRentAmount),
              OctRent: this.getActualAmountFromInp(OctRentAmount),
              NovRent: this.getActualAmountFromInp(NovRentAmount),
              DecRent: this.getActualAmountFromInp(DecRentAmount)
            }

            const res = await this.operationRentalService.getBoothRentalCombinedMonthlyCharges(obj).toPromise();
            if (res) {
              this.resetRentMonthsInGrid(res);
              const booth = this.selectedMonthlyBooths[recordExist];
              this.updateMonthlyBoothData(booth, res, rentalDates, marketDays, currentMonthRentalDates, this.selectedEndDates);

              this.totalRentalCharge += res.Rent.toString().includes('(') && res.Rent.toString().includes(')') ? -1 * parseFloat(res.Rent.toString().replace(/[^0-9.-]/g, '')) : parseFloat(res.Rent.toString().replace(/[^0-9.-]/g, ''));
              this.totalSalesTax += res.SalesTax.toString().includes('(') && res.SalesTax.toString().includes(')') ? -1 * parseFloat(res.SalesTax.toString().replace(/[^0-9.-]/g, '')) : parseFloat(res.SalesTax.toString().replace(/[^0-9.-]/g, ''));
              this.totalSecondLeveltax += res.CityTax.toString().includes('(') && res.CityTax.toString().includes(')') ? -1 * parseFloat(res.CityTax.toString().replace(/[^0-9.-]/g, '')) : parseFloat(res.CityTax.toString().replace(/[^0-9.-]/g, ''));
              this.setRentalCharges();
              this.isFormDirty.emit(true);
              this.gridMonthlyRental.refresh();
            }
          }
          else {
            nonAvailableBooths.push(this.selectedMonthlyBooths[recordExist].BoothNumber);
          }
        }
      }
    }
    this.disableSave = false;
    if (nonAvailableBooths.length > 0) {
      const nonAvailableBoothsString = nonAvailableBooths.join(', ');
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Cannot be renewed further as the booth number ` + nonAvailableBoothsString + ` is not available`,
        icon: "info",
        confirmButtonText: $localize`Ok`,
      });
    }
  }

  updateMonthlyBoothData(booth, res, rentalDates, marketDays, currentMonthRentalDates, endDate) {
    booth.RentEndPeriod = endDate;
    booth.RentalEndDate = this.datePipe.transform(new Date(rentalDates[rentalDates.length - 1].startDate), 'MMM d, y');
    booth.MktDays = marketDays;
    booth.Rent = this.customCurrency.transform(res.Rent);
    booth.SalesTax = this.customCurrency.transform(res.SalesTax);
    booth.CityTax = this.customCurrency.transform(res.CityTax);
    booth.January = this.customCurrency.transform(res.JanRent == null ? 0 : res.JanRent);
    booth.February = this.customCurrency.transform(res.FebRent == null ? 0 : res.FebRent);
    booth.March = this.customCurrency.transform(res.MarRent == null ? 0 : res.MarRent);
    booth.April = this.customCurrency.transform(res.AprRent == null ? 0 : res.AprRent);
    booth.May = this.customCurrency.transform(res.MayRent == null ? 0 : res.MayRent);
    booth.June = this.customCurrency.transform(res.JunRent == null ? 0 : res.JunRent);
    booth.July = this.customCurrency.transform(res.JulRent == null ? 0 : res.JulRent);
    booth.August = this.customCurrency.transform(res.AugRent == null ? 0 : res.AugRent);
    booth.September = this.customCurrency.transform(res.SepRent == null ? 0 : res.SepRent);
    booth.October = this.customCurrency.transform(res.OctRent == null ? 0 : res.OctRent);
    booth.November = this.customCurrency.transform(res.NovRent == null ? 0 : res.NovRent);
    booth.December = this.customCurrency.transform(res.DecRent == null ? 0 : res.DecRent);
    booth.JanuaryMonthPresent = res.JanuaryMonthPresent;
    booth.FebruaryMonthPresent = res.FebruaryMonthPresent;
    booth.MarchMonthPresent = res.MarchMonthPresent;
    booth.AprilMonthPresent = res.AprilMonthPresent;
    booth.MayMonthPresent = res.MayMonthPresent;
    booth.JuneMonthPresent = res.JuneMonthPresent;
    booth.JulyMonthPresent = res.JulyMonthPresent;
    booth.AugustMonthPresent = res.AugustMonthPresent;
    booth.SeptemberMonthPresent = res.SeptemberMonthPresent;
    booth.OctoberMonthPresent = res.OctoberMonthPresent;
    booth.NovemberMonthPresent = res.NovemberMonthPresent;
    booth.DecemberMonthPresent = res.DecemberMonthPresent;
    booth.DisableJanMonth = res.JanRent || res.JanRent == 0 ? false : true;
    booth.DisableFebMonth = res.FebRent || res.FebRent == 0 ? false : true;
    booth.DisableMarMonth = res.MarRent || res.MarRent == 0 ? false : true;
    booth.DisableAprMonth = res.AprRent || res.AprRent == 0 ? false : true;
    booth.DisableMayMonth = res.MayRent || res.MayRent == 0 ? false : true;
    booth.DisableJunMonth = res.JunRent || res.JunRent == 0 ? false : true;
    booth.DisableJulMonth = res.JulRent || res.JulRent == 0 ? false : true;
    booth.DisableAugMonth = res.AugRent || res.AugRent == 0 ? false : true;
    booth.DisableSepMonth = res.SepRent || res.SepRent == 0 ? false : true;
    booth.DisableOctMonth = res.OctRent || res.OctRent == 0 ? false : true;
    booth.DisableNovMonth = res.NovRent || res.NovRent == 0 ? false : true;
    booth.DisableDecMonth = res.DecRent || res.DecRent == 0 ? false : true;
    booth.StartDateList = currentMonthRentalDates;
    booth.ExtendRental = true;
    booth.AllRentalDates = rentalDates.map(el => new Date(el.startDate));
    booth.TaxModel = res.TaxModel;
  }

  renewOtherCharges() {
    if (this.selectedOtherItems.length > 0) {
      var recurringItemExist = this.selectedOtherItems.filter(e => e.Recurring && new Date(e.RentalMonth)
        < new Date(this.selectedEndDates.split('-')[0]));
      if (recurringItemExist.length > 0) {
        // if (this.PromptRenewOther) {
        Swal.fire({
          title: $localize`Confirm`,
          text: $localize`Do you want to renew recurring other charges till ` + this.selectedEndDates + '?',
          icon: "question",
          showCancelButton: true,
          confirmButtonText: $localize`Yes`,
          cancelButtonText: $localize`No`,
        }).then((result) => {
          if (result.value) {
            this.proceedRenewingOtherCharges();
          }
        })
        // }
        // else {
        //   this.proceedRenewingOtherCharges();
        // }
      }
    }
  }

  async proceedRenewingOtherCharges() {
    for (const item of this.selectedOtherItems) {
      const endMonth = new Date(this.selectedEndDates);
      const currentMonth = new Date(item.RentalMonth);
      while (currentMonth < endMonth && item.Recurring) {
        var nextDate = currentMonth.setMonth(currentMonth.getMonth() + 1);
        var rentalMonthDate = this.monthlyMarketDays.filter(date => this.datePipe.transform(new Date(date.RentalMonths), 'MM/dd/yyyy') <= this.datePipe.transform(new Date(nextDate), 'MM/dd/yyyy')
          && this.datePipe.transform(new Date(date.RentalMonths), 'MM/dd/yyyy') >= this.datePipe.transform(new Date(nextDate), 'MM/dd/yyyy'))
        if (rentalMonthDate.length > 0)
          var rentalStartMonth = rentalMonthDate[0].RentalMonths;

        var recordExist = this.selectedOtherItems.findIndex(e => e.RentalMonth == rentalStartMonth && e.Id == item.Id && e.Reference == item.Reference && e.BoothNo == item.BoothNo)
        var otherItemCharge = this.otherItemList.filter(e => e.Id == item.Id)[0].OtherItemCharge;
        if (!this.masterRentChargeforResOtherItems && this.allrentedOtherItems.length > 0) {
          otherItemCharge = this.customCurrency.transform(this.allrentedOtherItems.filter(e => e.OtherItemId == item.Id)[0].OtherCharge);
        }

        var obj = {
          OtherItemId: item.Id,
          VendorId: this.vendorId,
          Quantity: item.Quantity,
          OtherItemCharge: otherItemCharge.includes('(') && otherItemCharge.includes(')') ? (-1) * parseFloat(otherItemCharge.replace(/[^0-9.-]/g, '')) : parseFloat(otherItemCharge.replace(/[^0-9.-]/g, ''))
        }

        const res = await this.operationRentalService.getOtherItemsRentalCharges(obj).toPromise();
        if (res) {
          if (recordExist == -1) {
            const isNegative = otherItemCharge.includes('(') && otherItemCharge.includes(')');
            const totalValue = parseFloat(otherItemCharge.replace(/[^0-9.-]/g, ''));
            const finalCharge = isNegative ? -totalValue : totalValue;
            var otherItemtotal = this.customCurrency.transform((finalCharge * item.Quantity).toString());
            const ob = {
              Id: item.Id,
              MonthOtherRentalId: 0,
              OtherItem: item.OtherItem,
              OtherItemCharge: otherItemCharge,
              Quantity: item.Quantity,
              OtherItemtotal: otherItemtotal,
              RentalMonth: rentalStartMonth,
              SalesTax: this.customCurrency.transform(res.SalesTax.toString()),
              CityTax: this.customCurrency.transform(res.CityTax.toString()),
              BoothNo: item.BoothNo ?? "none",
              Recurring: item.Recurring,
              NewItem: true,
              Reference: item.Reference,
              MonthlyRentalIds: ''
            }
            this.selectedOtherItems.push(JSON.parse(JSON.stringify(ob)));
            this.totalOtherRentalCharge += otherItemtotal.toString().includes('(') && otherItemtotal.toString().includes(')') ? -1 * parseFloat(otherItemtotal.toString().replace(/[^0-9.-]/g, '')) : parseFloat(otherItemtotal.toString().replace(/[^0-9.-]/g, ''));
            this.totalSalesTax += res.SalesTax.toString().includes('(') && res.SalesTax.toString().includes(')') ? -1 * parseFloat(res.SalesTax.toString().replace(/[^0-9.-]/g, '')) : parseFloat(res.SalesTax.toString().replace(/[^0-9.-]/g, ''));
            this.totalSecondLeveltax += res.CityTax.toString().includes('(') && res.CityTax.toString().includes(')') ? -1 * parseFloat(res.CityTax.toString().replace(/[^0-9.-]/g, '')) : parseFloat(res.CityTax.toString().replace(/[^0-9.-]/g, ''));
          }
          this.setRentalCharges();
          this.disableSave = false;
          this.isFormDirty.emit(true);
          this.gridOtherRental.refresh();
        }
      }
    }
  }

  saveCombinedMonthlyRental(payByBooth) {
    const bookingAvailable =
      this.selectedMonthlyBooths.some(b => b.NewBooth || b.ExtendRental) ||
      this.selectedOtherItems.some(i => i.NewItem);

    if (!bookingAvailable) {
      this.proceedSavingRental(payByBooth);
      return;
    }

    var rentalBookingAvailable = this.selectedMonthlyBooths.some(b => b.NewBooth || b.ExtendRental);
    if (!payByBooth && rentalBookingAvailable) {
      var totalRentalCharge = this.getActualAmountFromInp(this.rentalForm.controls['vendorBalances'].value['totalRentalCharge']);
      if (totalRentalCharge == 0) {
        Swal.fire({
          title: $localize`Confirm`,
          text: $localize`Rental charge equals zero. Are you sure you want to continue?`,
          icon: "question",
          showCancelButton: true,
          confirmButtonText: $localize`Yes`,
          cancelButtonText: $localize`No`,
        }).then((result) => {
          if (result.value) {
            this.proceedSavingRental(payByBooth);
          }
        });
      } else {
        this.proceedSavingRental(payByBooth);
      }
    } else {
      this.proceedSavingRental(payByBooth);
    }
  }

  onCheckNumKeyPress(event: KeyboardEvent) {
    const allowedChars = /[0-9]/g;
    const key = event.key;
    if (event.key === 'Backspace' || event.key === 'Delete' || event.key === 'ArrowLeft' || event.key === 'ArrowRight' || event.key === '#') {
      return;
    }
    if (!key.match(allowedChars)) {
      event.preventDefault();
    }
  }

  // Applies available vendor credits to rental dues. It applies starting from previous dues
  async applyVendorCreditToDues(dues: any[], priorBalance: number): Promise<{ applied: number; remaining: number }> {

    let localCredit = 0;
    const vendorBalance = -1 * priorBalance;

    // A negative new due represents a LOCAL CREDIT.
    for (const record of dues) {
      const dueTotal = (record.CurrentAmount ?? 0) + (record.Tax1 ?? 0) + (record.Tax2 ?? 0);
      if (dueTotal < 0) {
        record.PaidTill = dueTotal;// Negative due is fully realized as a credit.
        record.ChargeStatus = 'F';// Negative dues are fully processed.
        localCredit += Math.abs(dueTotal);  // Convert -100 into +100 available credit.
      }
    }

    // Fetch existing vendor rental dues once and reuse them below.
    const previousDues: any[] = (await lastValueFrom(
      this.operationRentalService.getVendorRentalDues(this.vendorId)
    )) ?? [];

    // IF vendor Balance IS ZERO OR POSITIVE
    // In this case we DO NOT fetch/use vendor credit as it already reflects in the vendor balance.
    // Local credit can be used against NEW positive dues.
    if (vendorBalance >= 0) {
      const remainingLocalCredit = this.distributeCreditAcrossDues(dues, localCredit + vendorBalance);

      for (const record of previousDues) {
        const due = (record.CurrentAmount ?? 0) + (record.Tax1 ?? 0) + (record.Tax2 ?? 0);
        record.ChargeStatus = 'F';
        record.PaidTill = due;
      }

      if (previousDues.length) {
        this.addOrUpdateDues(dues, previousDues);
      }

      return {
        applied: (localCredit + vendorBalance) - remainingLocalCredit,
        remaining: remainingLocalCredit
      };
    }

    // vendor Balance IS NEGATIVE
    // Now the vendor already has a due balance.
    // The order to apply the credits is
    //   A. Existing credit dues
    //   B. Vendor credit
    //   C. Local credit

    // UPDATE/RESOLVE EXISTING CREDIT DUES FIRST
    // Existing negative dues represent previously accumulated vendor credits.
    // We first process those records before touching the new positive dues.
    let previousNegativeDuesCredit = 0;

    const updatedOldNegativeDues: any[] = [];

    for (const oldDue of previousDues) {
      const oldTotal = (oldDue.CurrentAmount ?? 0) + (oldDue.Tax1 ?? 0) + (oldDue.Tax2 ?? 0);
      if (oldTotal >= 0) {
        continue;
      }
      previousNegativeDuesCredit += Math.abs(oldTotal);// Existing negative due becomes available credit.
      oldDue.PaidTill = oldTotal;
      oldDue.ChargeStatus = 'F'; // Mark the old negative due as fully processed.
      updatedOldNegativeDues.push(oldDue);
    }

    // Put the latest versions of the old negative dues into the main dues collection.
    this.addOrUpdateDues(dues, updatedOldNegativeDues);

    // GET VENDOR CREDIT
    let vendorCredit = 0;
    const boothCredit: any = await lastValueFrom(this.operationRentalService.getVendorBoothCredit(this.vendorId));

    if (boothCredit && !boothCredit.DisplayApplyCredit) {
      vendorCredit = this.getActualAmountFromInp(boothCredit.CreditAmount ?? 0);
    }

    // GET EXISTING POSITIVE DUES
    const previousPositiveDues = previousDues.filter(oldDue => {
      const oldTotal = (oldDue.CurrentAmount ?? 0) + (oldDue.Tax1 ?? 0) + (oldDue.Tax2 ?? 0);
      const paidTill = oldDue.PaidTill ?? 0;
      // Only unpaid/partially-paid positive dues.
      return oldTotal > 0 && oldDue.ChargeStatus !== 'F' && (oldTotal - paidTill) > 0;
    });

    // CALCULATE HOW MUCH IS REQUIRED FOR OLD POSITIVE DUES
    let oldPositiveDuesRequired = 0;
    for (const oldDue of previousPositiveDues) {
      const oldTotal = (oldDue.CurrentAmount ?? 0) + (oldDue.Tax1 ?? 0) + (oldDue.Tax2 ?? 0);
      const paidTill = oldDue.PaidTill ?? 0;
      const remainingDue = Math.max(0, oldTotal - paidTill);
      oldPositiveDuesRequired += remainingDue;
    }

    // USE EXISTING NEGATIVE DUES CREDIT FIRST
    let creditRequiredForOldDues = oldPositiveDuesRequired;
    if (previousNegativeDuesCredit > 0 && creditRequiredForOldDues > 0) {
      const creditToUse = Math.min(previousNegativeDuesCredit, creditRequiredForOldDues);
      const updatedOldPositiveDues1: any[] = [];
      const remainingAfterOldCredit = this.distributeCreditAcrossDues(previousPositiveDues, creditToUse, updatedOldPositiveDues1);
      const actualOldCreditUsed = creditToUse - remainingAfterOldCredit;
      previousNegativeDuesCredit -= actualOldCreditUsed;
      creditRequiredForOldDues -= actualOldCreditUsed;
      // The positive old dues were modified inside previousPositiveDues.
      // Put those latest versions back into dues.
      this.addOrUpdateDues(dues, updatedOldPositiveDues1);
    }

    // USE VENDOR CREDIT FOR REMAINING OLD POSITIVE DUES
    if (vendorCredit > 0 && creditRequiredForOldDues > 0) {
      const creditToUse = Math.min(vendorCredit, creditRequiredForOldDues);
      const updatedOldPositiveDues2: any[] = [];
      const remainingAfterVendorCredit = this.distributeCreditAcrossDues(previousPositiveDues, creditToUse, updatedOldPositiveDues2);
      const actualVendorCreditUsed = creditToUse - remainingAfterVendorCredit;
      vendorCredit -= actualVendorCreditUsed;
      creditRequiredForOldDues -= actualVendorCreditUsed;
      // Push/update the latest positive old dues.
      this.addOrUpdateDues(dues, updatedOldPositiveDues2);
    }

    // USE LOCAL CREDIT FOR REMAINING OLD POSITIVE DUES
    let localCreditAppliedToOldDues = 0;
    if (localCredit > 0 && creditRequiredForOldDues > 0) {
      const creditToUse = Math.min(localCredit, creditRequiredForOldDues);
      const updatedOldPositiveDues3: any[] = [];
      const remainingAfterLocalCredit = this.distributeCreditAcrossDues(previousPositiveDues, creditToUse, updatedOldPositiveDues3);
      localCreditAppliedToOldDues = creditToUse - remainingAfterLocalCredit;
      localCredit -= localCreditAppliedToOldDues;
      creditRequiredForOldDues -= localCreditAppliedToOldDues;
      // Push/update the latest positive old dues.
      this.addOrUpdateDues(dues, updatedOldPositiveDues3);
    }

    // NOW ALL OLD POSITIVE DUES ARE HANDLED AS FAR AS AVAILABLE CREDIT ALLOWS.
    // ANY REMAINING VENDOR CREDIT CAN BE USED ON NEW DUES.
    if (vendorCredit > 0) {
      const updatedNewDues1: any[] = [];
      vendorCredit = this.distributeCreditAcrossDues(dues, vendorCredit, updatedNewDues1);
      this.addOrUpdateDues(dues, updatedNewDues1);
    }

    // USE REMAINING LOCAL CREDIT ON NEW POSITIVE DUES
    const localCreditBeforeNewDues = localCredit;
    if (localCredit > 0) {
      const updatedNewDues2: any[] = [];
      localCredit = this.distributeCreditAcrossDues(dues, localCredit, updatedNewDues2);
      this.addOrUpdateDues(dues, updatedNewDues2);
    }

    const localCreditAppliedToNewDues = localCreditBeforeNewDues - localCredit;
    const totalLocalCreditApplied = localCreditAppliedToOldDues + localCreditAppliedToNewDues;

    return {
      applied: totalLocalCreditApplied,
      remaining: localCredit
    };
  }

  private addOrUpdateDues(dues: any[], updatedDues: any[]): void {

    for (const updatedDue of updatedDues) {

      const existingIndex = dues.findIndex(x =>
        x.VendorId === updatedDue.VendorId &&
        x.AccountReceiptId === updatedDue.AccountReceiptId &&
        x.RentalBoothOrOtherID === updatedDue.RentalBoothOrOtherID &&
        x.RentalId === updatedDue.RentalId
      );

      if (existingIndex >= 0) {
        // Replace the existing record with the latest values.
        dues[existingIndex] = {
          ...dues[existingIndex],
          ...updatedDue
        };

      } else {
        dues.push({
          ...updatedDue
        });
      }
    }
  }

  private distributeCreditAcrossDues(dues: any[], creditAmount: number, touched?: any[]): number {

    let creditRemaining = creditAmount;

    if (!dues?.length || creditRemaining <= 0) {
      return creditRemaining;
    }

    const sortedDues = [...dues].sort((a, b) => {
      // 1. OTHER CHARGES FIRST
      const aIsOther = a.ChargeType === 'O' ? 0 : 1;
      const bIsOther = b.ChargeType === 'O' ? 0 : 1;
      if (aIsOther !== bIsOther) {
        return aIsOther - bIsOther;
      }
      // 2. WITHIN THE SAME TYPE, OLDEST DATE FIRST
      const dateA = new Date(a.TransactionDate).getTime();
      const dateB = new Date(b.TransactionDate).getTime();
      return dateA - dateB;
    });

    for (const record of sortedDues) {
      if (creditRemaining <= 0) break;
      if (record.ChargeStatus === 'F') continue;
      const total = (record.CurrentAmount ?? 0) + (record.Tax1 ?? 0) + (record.Tax2 ?? 0);
      if (total <= 0) continue;
      const alreadyPaid = record.PaidTill ?? 0;
      const remainingDue = total - alreadyPaid;
      if (remainingDue <= 0) continue;
      const creditUsed = Math.min(remainingDue, creditRemaining);
      record.PaidTill = alreadyPaid + creditUsed;
      record.ChargeStatus = record.PaidTill >= total ? 'F' : (record.PaidTill > 0 ? 'P' : 'U');
      creditRemaining -= creditUsed;
      touched?.push(record);
    }
    return creditRemaining;
  }

  async proceedSavingRental(payByBooth) {
    this.disableSave = true;
    this.isFormDirty.emit(false);
    this.loaderIcon = Promise.resolve(true);
    await this.updateInput();
    setTimeout(async () => {
      var priorBalance = this.getActualAmountFromInp(this.rentalForm.controls['vendorBalances'].value['vendorPriorBalance']);
      var totalRentalCharge = this.getActualAmountFromInp(this.rentalForm.controls['vendorBalances'].value['totalRentalCharge']);
      var totalSalesTax = this.getActualAmountFromInp(this.rentalForm.controls['vendorBalances'].value['totalSalesTax']);
      var totalSecondLeveltax = this.getActualAmountFromInp(this.rentalForm.controls['vendorBalances'].value['totalSecondLeveltax']);
      var totalOtherRentalCharge = this.getActualAmountFromInp(this.rentalForm.controls['vendorBalances'].value['totalOtherRentalCharge'])
      var totalCharge = this.getActualAmountFromInp(this.rentalForm.controls['vendorBalances'].value['totalCharge']);

      var obj = {
        VendorId: this.vendorId,
        PriorBalance: priorBalance,
        RentalCharge: totalRentalCharge,
        SalesTax: totalSalesTax,
        SecLevelTax: totalSecondLeveltax,
        OtherCharge: totalOtherRentalCharge,
        TotalBalanceDue: totalCharge,
        RentalNotes: this.defaultRentalNotes,
        PaymentDone: false,
        MonthlyRentalBooth: [],
        MonthlyOtherRentalCharges: []
      }

      var objSelectedBooth = [];
      var objDuesRecord = [];
      if (this.selectedMonthlyBooths.length > 0) {
        this.selectedMonthlyBooths.forEach((item, i) => {
          const rentalStartDateYear = new Date(item.RentalEndDate).getFullYear();
          const rentalStartDateMonth = new Date(item.RentalEndDate).getMonth() + 1;
          const rentalStartDateYearMonth = `${rentalStartDateYear}${rentalStartDateMonth < 10 ? '0' : ''}${rentalStartDateMonth}`;
          objSelectedBooth.push({
            MonthlyRentalId: item.MonthlyRentalId,
            BoothNumber: item.BoothNumber,
            BoothTypeId: item.BoothTypeId,
            ProductId: item.Product,
            BoothType: item.BoothType,
            RentalStartDate: this.formatDateOnly(item.RentalStartDate),
            RentalEndDate: this.formatDateOnly(item.RentalEndDate),
            RentalYearMonth: rentalStartDateYearMonth,
            BoothReserved: item.Reservation,
            DoNotRenew: item.Drop,
            PerDiem: item.PerDiem,
            PerdiemRent: this.getActualAmountFromInp(item.PerDiemRent),
            Monday: item.Monday,
            Tuesday: item.Tuesday,
            Wednesday: item.Wednesday,
            Thursday: item.Thursday,
            Friday: item.Friday,
            Saturday: item.Saturday,
            Sunday: item.Sunday,
            RentalCharge: this.getActualAmountFromInp(item.Rent),
            SalesTax: this.getActualAmountFromInp(item.SalesTax),
            SecLevelTax: this.getActualAmountFromInp(item.CityTax),
            JanRent: item.January ? this.getActualAmountFromInp(item.January) : 0,
            FebRent: item.February ? this.getActualAmountFromInp(item.February) : 0,
            MarRent: item.March ? this.getActualAmountFromInp(item.March) : 0,
            AprRent: item.April ? this.getActualAmountFromInp(item.April) : 0,
            MayRent: item.May ? this.getActualAmountFromInp(item.May) : 0,
            JunRent: item.June ? this.getActualAmountFromInp(item.June) : 0,
            JulRent: item.July ? this.getActualAmountFromInp(item.July) : 0,
            AugRent: item.August ? this.getActualAmountFromInp(item.August) : 0,
            SepRent: item.September ? this.getActualAmountFromInp(item.September) : 0,
            OctRent: item.October ? this.getActualAmountFromInp(item.October) : 0,
            NovRent: item.November ? this.getActualAmountFromInp(item.November) : 0,
            DecRent: item.December ? this.getActualAmountFromInp(item.December) : 0,
            BookingLog: i + 1,
            AllRentalDates: item.AllRentalDates,
            TaxModel: item.TaxModel
          });

          if (item.ExtendRental || item.NewBooth) {
            if (item.TaxModel != null && item.TaxModel.length > 0) {
              for (var rentalData of item.TaxModel) {
                var total = (this.getActualAmountFromInp(rentalData.RentalPeriodPrice) ?? 0) + (this.getActualAmountFromInp(rentalData.SalesTax) ?? 0) + (this.getActualAmountFromInp(rentalData.SecondTax) ?? 0);
                objDuesRecord.push({
                  DueChargeDescription: 'Comb Monthly Rental',
                  CurrentAmount: this.getActualAmountFromInp(rentalData.RentalPeriodPrice),
                  Tax1: this.getActualAmountFromInp(rentalData.SalesTax),
                  Tax2: this.getActualAmountFromInp(rentalData.SecondTax),
                  PriorBalance: 0,
                  Deletion: false,
                  Total: total,
                  PaidTill: 0,
                  ChargeType: 'R',
                  RentalBoothOrOtherID: item.BoothNumber,
                  VendorId: this.vendorId,
                  RentalId: 0,
                  OtherBoothNumber: "",
                  RentalPeriod: rentalData.YearMonth,
                  AccountReceiptId: 0,
                  RentalPeriodToDisp: this.formatYearMonth(rentalData.YearMonth),
                  TransactionDate: new Date()
                });
              }
            }
          }
        });
      }

      if (objSelectedBooth.length > 0)
        obj.MonthlyRentalBooth = objSelectedBooth;

      var objSelectedOtherCharge = [];
      if (this.selectedOtherItems.length > 0) {
        this.selectedOtherItems.forEach((item) => {
          const otherRentalYear = new Date(item.RentalMonth.split('-')[0]).getFullYear();
          const otherRentalMonth = new Date(item.RentalMonth.split('-')[0]).getMonth() + 1;
          const otherRentalYearMonth = `${otherRentalYear}${otherRentalMonth < 10 ? '0' : ''}${otherRentalMonth}`;

          objSelectedOtherCharge.push({
            OtherItemId: item.Id,
            MonthOtherRentalId: item.MonthOtherRentalId,
            Quantity: item.Quantity,
            YearMonth: otherRentalYearMonth,
            BoothNumber: item.BoothNo,
            Recurring: item.Recurring,
            OtherCharge: this.getActualAmountFromInp(item.OtherItemCharge),
            SalesTax: this.getActualAmountFromInp(item.SalesTax),
            SecLevelTax: this.getActualAmountFromInp(item.CityTax),
            Reference: item.Reference?.trim(),
            MonthlyRentalIds: item.MonthlyRentalIds,
          });

          if (item.NewItem || item.Status === "R") {
            var otherItemCharge = this.getActualAmountFromInp(item.OtherItemCharge) * item.Quantity;
            objDuesRecord.push({
              DueChargeDescription: 'Comb Monthly Other',
              CurrentAmount: otherItemCharge,
              Tax1: this.getActualAmountFromInp(item.SalesTax),
              Tax2: this.getActualAmountFromInp(item.CityTax),
              PriorBalance: 0,
              Deletion: false,
              Total: (this.getActualAmountFromInp(item.OtherItemtotal) ?? 0),
              PaidTill: 0,
              ChargeType: 'O',
              RentalBoothOrOtherID: (item.Id).toString(),
              VendorId: this.vendorId,
              RentalId: 0,
              OtherBoothNumber: item.BoothNumber ?? "",
              RentalPeriod: otherRentalYearMonth,
              OtherItem: item.OtherItem,
              AccountReceiptId: 0,
              RentalPeriodToDisp: item.RentalMonth,
              TransactionDate: new Date()
            });
          }
        });
      }
      if (objSelectedOtherCharge.length > 0)
        obj.MonthlyOtherRentalCharges = objSelectedOtherCharge;

      this.Dues = objDuesRecord;

      let creditApplied = 0;
      let creditRemainingBalance = 0;
      if (!payByBooth) {
        const creditResult = await this.applyVendorCreditToDues(objDuesRecord, priorBalance);
        creditApplied = creditResult.applied;
        creditRemainingBalance = creditResult.remaining;
      }

      if (!payByBooth) {
        this.subscriptions.push(this.operationRentalService.saveCombinedMonthlyRental(obj).subscribe(async (res: any) => {
          if (res.Success) {
            if (res.Id) {
              var obj = {
                AccountReceiptId: res.Id,
                CashAmount: 0,
                CheckAmount: 0,
                CheckNo: "",
                CardAmount: 0,
                DirectDebitAmount: 0,
                CardType: "",
                PaymentDone: false,
                ChangeAmount: 0,
                PaymentOrderId: "",
                VerifoneId: 0,
                PaymentOnly: false,
                DueRecordModel: this.Dues,
                VendorId: this.vendorId,
                CreditApplied: creditApplied,
                RemainingCreditAmount: creditRemainingBalance
              }
              const response: any = await firstValueFrom(
                this.operationRentalService.saveVendorRentalDues(obj)
              );

              await this.printReceiptAndContracts(res.Id);
            }
            this.toastr.success($localize`Transaction saved successfully`, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
            this.totalRentalCharge = 0.00;
            this.totalSalesTax = 0.00;
            this.totalSecondLeveltax = 0.00;
            this.totalOtherRentalCharge = 0.00;
            this.setRentalCharges();
          }
          else {
            this.toastr.error($localize`Error occured while saving the rental transaction`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
            this.totalRentalCharge = 0.00;
            this.totalSalesTax = 0.00;
            this.totalSecondLeveltax = 0.00;
            this.totalOtherRentalCharge = 0.00;
            this.setRentalCharges();
          }
          this.disableSave = true;
          this.getVendorBalances();
          this.getMonthlyRental();
          this.loaderIcon = Promise.resolve(false);
        }, (err) => {
          this.toastr.error($localize`Error occured while saving the rental transaction`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig)
          this.loaderIcon = Promise.resolve(false);
        }));
      }
      else {
        this.loaderIcon = Promise.resolve(false);
        this.rentalModel = obj;
        this.disableSave = true;
        this.payByBooth = true;
        this.openModalById('payByBoothModal');
        this.hideTopHeaders.emit(true);
      }

      var temp = {
        TempRecordNo: this.tempRecordNo.toString(),
        BoothNo: ""
      }
      this.subscriptions.push(this.operationRentalService.deleteFromTemp(temp).subscribe((res: any) => {
      }));
    }, 500);
  }

  formatYearMonth(yyyymm: string | number): string {
    const str = yyyymm.toString();

    const year = str.substring(0, 4);
    const monthNumber = parseInt(str.substring(4, 6), 10);

    const monthName = new Date(0, monthNumber - 1).toLocaleString('en-US', {
      month: 'long'
    });

    return `${monthName} ${year}`;
  }

  private formatDateOnly(value: any): string {
    if (!value) {
      return null;
    }
    const date = new Date(value);
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  }

  closePayByBoothPopup() {
    Swal.fire({
      title: $localize`Confirm`,
      text: $localize`Are you sure you want to go back ?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: $localize`Yes`,
      cancelButtonText: $localize`No`,
    }).then((result) => {
      if (result.value) {
        this.payByBooth = false;
        this.disableSave = false;
        this.closeModalById('payByBoothModal');
        this.hideTopHeaders.emit(false);
      }
    });
  }

  cancelPayByBooth(val) {
    this.payByBooth = !val;
    this.disableSave = false;
    if (!this.payByBooth) {
      this.closeModalById('payByBoothModal');
    }
    this.hideTopHeaders.emit(false);
  }

  closePayByBooth(val) {
    this.payByBooth = !val;
    if (!this.payByBooth) {
      this.closeModalById('payByBoothModal');
    }
    this.hideTopHeaders.emit(false);
    this.totalRentalCharge = 0.00;
    this.totalSalesTax = 0.00;
    this.totalSecondLeveltax = 0.00;
    this.totalOtherRentalCharge = 0.00;
    this.setRentalCharges();
    this.disableSave = true;
    setTimeout(() => {
      this.getVendorBalances();
      this.getMonthlyRental();
    }, 0)
  }

  deleteSelectedBooth(data) {
    if (data.Status == "R") {
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Are you sure you want to delete the reservation?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: $localize`Yes`,
        cancelButtonText: $localize`No`,
      }).then((result) => {
        if (result.value) {
          const index = this.selectedMonthlyBooths.findIndex(selectedBooth => selectedBooth.BoothNumber === data.BoothNumber && selectedBooth.RentStartPeriod == data.RentStartPeriod && selectedBooth.RentEndPeriod == data.RentEndPeriod);
          if (index !== -1) {
            this.selectedMonthlyBooths.splice(index, 1);
          }
          this.totalRentalCharge -= this.getActualAmountFromInp(data.Rent);
          this.totalSalesTax -= this.getActualAmountFromInp(data.SalesTax);
          this.totalSecondLeveltax -= this.getActualAmountFromInp(data.CityTax);
          this.setRentalCharges();
          this.gridMonthlyRental.refresh();

          var obj = {
            BoothNumber: data.BoothNumber,
            RentalId: data.MonthlyRentalId,
            VendorId: this.vendorId,
            RentalType: 4
          }
          Swal.fire({
            title: $localize`Confirm`,
            text: $localize`Do you want to make the booth available?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: $localize`Yes`,
            cancelButtonText: $localize`No`,
          }).then((result) => {
            if (result.value) {
              this.subscriptions.push(this.operationRentalService.deleteCombinedMonthlyReservation(obj).subscribe((res: any) => {
                if (res.Success) {
                  this.toastr.success($localize`Booth has been made available`, $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
                }
                else {
                  this.toastr.error($localize`Error occured while making booth available`, $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
                }
              }));
            }
          });
        }
      });
    }
    else if (!data.NewBooth) {
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Old Booking cannot be deleted`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
    }
    else {
      Swal.fire({
        title: $localize`Confirm`,
        text: $localize`Are you sure you want to delete the selected Booth`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: $localize`Yes`,
        cancelButtonText: $localize`No`,
      }).then((result) => {
        if (result.value) {
          const index = this.selectedMonthlyBooths.findIndex(selectedBooth => selectedBooth.BoothNumber === data.BoothNumber && selectedBooth.RentStartPeriod == data.RentStartPeriod && selectedBooth.RentEndPeriod == data.RentEndPeriod);
          if (index !== -1) {
            this.selectedMonthlyBooths.splice(index, 1);
          }
          if (this.tempRecordNo) {
            const temp = {
              TempRecordNo: this.tempRecordNo.toString(),
              BoothNo: data.BoothNumber,
              StartDate: new Date(data.RentalStartDate),
              RentalType: 4,
              EndDate: new Date(data.RentalEndDate),
              Sunday: data.Sunday,
              Monday: data.Monday,
              Tuesday: data.Tuesday,
              Wednesday: data.Wednesday,
              Thursday: data.Thursday,
              Friday: data.Friday,
              Saturday: data.Saturday
            }
            this.subscriptions.push(this.operationRentalService.deleteFromTemp(temp).subscribe((res: any) => {
            }));
          }

          this.totalRentalCharge -= this.getActualAmountFromInp(data.Rent);
          this.totalSalesTax -= this.getActualAmountFromInp(data.SalesTax);
          this.totalSecondLeveltax -= this.getActualAmountFromInp(data.CityTax);
          this.setRentalCharges();
          this.gridMonthlyRental.refresh();
        }
      });
    }
  }

  disableSaveRental() {
    if (this.selectedMonthlyBooths.length == 0 && this.selectedOtherItems.length == 0)
      return true;
    else if (this.disableSave)
      return true;
    else
      return false
  }

  HandleReceipts(data) {
    if (data.showReceipt || data.print || data.email) {
      this.printReceiptAndContracts(data.receiptId, true, data);
    }
  }

  printReceiptAndContracts(accountReceiptId: number, bookingWithPayment = false, responseFromPayment = null) {
    this.loaderIcon = Promise.resolve(true);
    var settings = this.rentalForm.controls['ReceiptAndContractSetting'].value;
    if (bookingWithPayment) {
      settings.displayReceipt = responseFromPayment.showReceipt;
      settings.printReceipt = responseFromPayment.print;
      settings.emailReceipt = responseFromPayment.email;
      settings.displayContract = false;
      settings.printContract = false;
      settings.emailContract = false;
    }
    const bookingAvailable =
      this.selectedMonthlyBooths.some(e => e.NewBooth || e.ExtendRental) ||
      this.selectedOtherItems.some(e => e.NewItem);

    if (!bookingAvailable) return;

    // Helper to generate and process a PDF
    const generateAndProcessPDF = (
      type: 'Receipt' | 'Contract',
      documentId: number,
      display: boolean,
      print: boolean,
      email: boolean,
      baseTemplateId: number,
      emailSubject: string
    ) => {
      const params = {
        VendorId: parseInt(this.vendorId),
        AccountReceiptId: accountReceiptId,
        RentalType: 4,
        PaymentOnly: false,
        DocumentId: documentId,
        PaymentWithBooking: bookingWithPayment,
        LaserThermalReceipt: this.laserThermalReceipt
      };

      this.subscriptions.push(
        this.operationRentalService.generatePaymentReceipt(params).subscribe((res: any) => {
          this.loaderIcon = Promise.resolve(false);
          if (!res.Success) return;
          const message = res.Message;

          if (!message || !message.startsWith('data:application/pdf;base64,')) {
            Swal.fire('Error', `Invalid ${type} PDF data in response`, 'error');
            return;
          }

          if (print && type == 'Receipt' && this.printThermalReceipt) {
            let params = 'methodname=RentalPaymentReceipt&param1=' + accountReceiptId + '&param2=4&param3=' + parseInt(this.vendorId) + '&param4=False&param5=' + this.thermalReceiptCopies + '&uniqueSessionId=' + this.uniqueSessionId;
            if (responseFromPayment != null) {
              if (responseFromPayment?.rentalMerchantCopy || responseFromPayment?.rentalCustomerCopy) {
                params += `&MerchantCopy=${responseFromPayment.rentalMerchantCopy}&CustomerCopy=${responseFromPayment.rentalCustomerCopy}&MerchantNoOfCopies=${responseFromPayment.rentalMerchantNoOfCopies}&CustomerNoOfCopies=${responseFromPayment.rentalCustomerNoOfCopies}`;
              }
            }

            const customProtocolUrl = `silentprinter://?${params}`;
            window.location.href = customProtocolUrl;
          }

          // --- DISPLAY PDF IN MODAL ---
          if (display) {
            this.showPDFModal(type, message);
          }

          // --- EMAIL PDF ---
          if (email) {
            this.sendEmail(
              accountReceiptId,
              baseTemplateId,
              message,
              `Rental ${type}`,
              emailSubject
            );
          }

          // --- PRINT PDF ---
          if (type == "Contract") {
            if (print) {
              printJS({
                printable: message.split(',')[1],
                type: 'pdf',
                base64: true,
              });
            }
          } else {
            if (print && !this.printThermalReceipt) {
              printJS({
                printable: message.split(',')[1],
                type: 'pdf',
                base64: true,
              });
            }
          }
        })
      );
    };

    // Handle Receipt
    if (settings.displayReceipt || settings.printReceipt || settings.emailReceipt) {
      generateAndProcessPDF(
        'Receipt',
        RentalReceiptIDs.MonthlyReceipt,
        settings.displayReceipt,
        settings.printReceipt,
        settings.emailReceipt,
        2,
        'Monthly Rental Receipt'
      );
    }

    // Handle Contract
    if (settings.displayContract || settings.printContract || settings.emailContract) {
      generateAndProcessPDF(
        'Contract',
        RentalReceiptIDs.MonthlyContract,
        settings.displayContract,
        settings.printContract,
        settings.emailContract,
        3,
        'Monthly Rental Contract'
      );
    }
  }

  private showPDFModal(type: 'Receipt' | 'Contract', base64Data: string) {
    this.loading = true;
    const modalId = type === 'Receipt' ? 'printReceiptPopup' : 'printContractPopup';
    const pdfVar = type === 'Receipt' ? 'receiptUrl' : 'contractUrl';

    const modalEl = document.getElementById(modalId);
    if (modalEl) {
      let modalInstance = window['bootstrap'].Modal.getInstance(modalEl);
      if (!modalInstance) {
        modalInstance = new window['bootstrap'].Modal(modalEl);
      }
      modalInstance.show();
    }

    const pdfBase64 = base64Data.split(',')[1];
    const blob = this.base64ToBlob(pdfBase64, 'application/pdf');
    this[pdfVar] = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
    this.loading = false;
  }

  private sendEmail(
    accountReceiptId: number,
    baseTemplateId: number,
    message: string,
    fileName: string,
    subject: string
  ) {
    const emailData = [{
      AccountReceiptID: accountReceiptId,
      VendorID: parseInt(this.vendorId),
      BaseTemplateID: baseTemplateId,
      AttachmentFile: message,
      AttachmentFileName: fileName,
      FileType: "application/pdf",
      Subject: subject
    }];

    this.generalService.composeEmails(emailData).subscribe(() => {
      console.log(`${subject} email sent successfully`);
    });
  }

  private base64ToBlob(base64: string, type: string): Blob {
    const byteCharacters = atob(base64);
    const byteArray = new Uint8Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteArray[i] = byteCharacters.charCodeAt(i);
    }
    return new Blob([byteArray], { type });
  }

  searchOtherItem() {
    const otherItemSearchText = this.rentalForm.controls['otherItemsScreen'].get('otherItemSearchText')?.value ?? '';
    // Do not reset isOtherItemChecked here.Preserve the restored checkbox states.
    if (otherItemSearchText.trim() !== '') {
      this.otherRentalCharges = this.otherItemList.filter(ele => ele.OtherItem?.toString().toLowerCase().includes(otherItemSearchText.toLowerCase()));
    } else {
      this.otherRentalCharges = [...this.otherItemList];
    }
  }

  rowOtherItemSelected(args) {
    this.gridOtherRental.getSelectedRecords().forEach(record => {
      const rows = this.gridOtherRental.getRows();
      for (let i = 0; i < rows.length; i++) {
        const currentRow = rows[i];
        this.applyStylesToRow(currentRow);
      }

      if (args.data.Status == "R") {
        for (let i = 0; i < args.row.cells.length; i++) {
          args.row.cells[i].style.backgroundColor = 'cyan';
        }
      }
    });
  }

  rowSelected(args) {
    this.gridMonthlyRental.getSelectedRecords().forEach(record => {
      const rows = this.gridMonthlyRental.getRows();
      for (let i = 0; i < rows.length; i++) {
        const currentRow = rows[i];
        this.applyStylesToRow(currentRow);
      }

      if (args.data.Status == "R") {
        for (let i = 0; i < args.row.cells.length; i++) {
          args.row.cells[i].style.backgroundColor = 'cyan';
        }
      }
    });
  }

  applyStylesToRow(row) {
    const cells = row.cells;
    // Loop through all cells and apply styles
    for (let j = 0; j < cells.length; j++) {
      cells[j].style.backgroundColor = '';
    }
  }

  async loadOtherItemsForBooking() {
    if (this.vendorIsInactive) {
      await Swal.fire({
        icon: 'warning',
        title: 'Inactive Vendor',
        text: 'Rental booking is not allowed for an inactive vendor.',
        confirmButtonText: 'OK'
      });
      return;
    }

    await this.getBoothsAndItemsForOtherCharges();
    this.openModalById('modalAddOtherRentals')
  }

  async getBoothsAndItemsForOtherCharges() {
    const rentalMonth = this.rentalForm.controls['otherItemsScreen'].get('otherChargeMarketMonth')?.value;
    this.rentalForm.controls['otherItemsScreen'].get('otherItemSearchText')?.setValue('');
    // Only restore items that were newly added to the main grid.
    // API-loaded/saved items (NewItem === false) remain unselected.
    this.boothsForOtherCharge = [];
    this.selectedOtherCharges = [];

    this.otherItemList.forEach(item => {
      // Find only records added through the popup for this month
      const existing = this.selectedOtherItems.find(
        record =>
          record.Id === item.Id &&
          record.RentalMonth === rentalMonth &&
          record.NewItem === true
      );

      if (existing) {
        // Restore the checkbox and saved values
        item.isOtherItemChecked = true;
        item.Quantity = existing.Quantity;
        item.OtherItemCharge = existing.OtherItemCharge;
        item.OtherItemtotal = existing.OtherItemtotal;
        item.Recurring = existing.Recurring;
        item.Reference = existing.Reference ?? '';
        item.othChgBooths = existing.BoothNo ?? 'none';

        // Restore the selected item in the popup collection
        this.selectedOtherCharges.push({
          Id: existing.Id,
          OtherItem: existing.OtherItem,
          OtherItemCharge: existing.OtherItemCharge,
          Quantity: existing.Quantity,
          OtherItemtotal: existing.OtherItemtotal,
          Recurring: existing.Recurring,
          Reference: existing.Reference ?? '',
          othChgBooths: existing.BoothNo ?? 'none',
          RentalMonth: existing.RentalMonth
        });
      } else {
        // Keep API-loaded records unchecked in the popup
        item.isOtherItemChecked = false;
        item.Quantity = 0;
        item.OtherItemtotal = this.customCurrency.transform('0');
        item.OtherItemCharge = item.DefaultOtherItemCharge;
        item.Recurring = item.DefaultRecurring ?? false;
        item.Reference = '';
        item.othChgBooths = 'none';
      }
    });

    this.otherRentalCharges = [...this.otherItemList];
    this.searchOtherItem();


    if (rentalMonth) {
      this.selectedMonthlyBooths.forEach(item => {
        if (item.RentStartPeriod == rentalMonth) {
          this.boothsForOtherCharge.push({ BoothNumber: item.BoothNumber });
        }
      });
    }

    if (this.boothsForOtherCharge.length > 0 && this.otherRentalCharges.length > 0) {
      for (const item of this.otherRentalCharges) {
        item.othChgBooths = "none"
      }
    }

    this.boothsForOtherCharge.sort((a, b) =>
      a.BoothNumber < b.BoothNumber ? -1 :
        a.BoothNumber > b.BoothNumber ? 1 : 0
    );

  }

  canDeactivate(): Observable<boolean> | boolean {
    if (this.disableSave) {
      const confirmPromise = Swal.fire({
        title: 'Confirm',
        text: 'Unsaved changes will be lost. Are you sure you want to continue?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.isConfirmed) {
          this.disableSave = false;
          this.isFormDirty.emit(false);
        }
        return result.isConfirmed;
      });
      return from(confirmPromise);
    }
    return true;
  }

  cancelRental() {
    if (!this.disableSave) {
      Swal.fire({
        title: $localize`Confirm`,
        text: $localize`Unsaved changes will be lost. Are you sure you want to cancel?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: $localize`Yes`,
        cancelButtonText: $localize`No`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.isFormDirty.emit(false);
          this.totalRentalCharge = 0.00;
          this.totalSalesTax = 0.00;
          this.totalSecondLeveltax = 0.00;
          this.totalOtherRentalCharge = 0.00;
          this.setRentalCharges();
          this.disableSave = true;
          this.getVendorBalances();
          this.getMonthlyRental();
        } else {
          //do nothing
        }
      });
    } else {
      var url = 'ops/vendors';
      this.router.navigate([url]);
    }
  }

  private showInactiveVendorMessage(): void {
    Swal.fire({
      icon: 'warning',
      title: 'Inactive Vendor',
      text: 'Rental booking is not allowed for an inactive vendor.',
      confirmButtonText: 'OK',
    });
  }

  onAddBoothClick(): void {

    if (this.vendorIsInactive) {
      this.showInactiveVendorMessage();
      return;
    }

    this.refreshAddBooth();
    this.openLayoutPopup(0);
    this.openModalById('modalAddNewMonthlyBooths');
  }

  onLayoutClick(): void {
    if (this.vendorIsInactive) {
      this.showInactiveVendorMessage();
      return;
    }

    this.refreshAddBooth();
    this.openLayoutPopup(1);
    this.openModalById('modalAddNewMonthlyBooths');
  }

  allowOnlyRentAmount(event: Event, data: any, field: string, allowNegative: boolean = false): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // Remove invalid characters depending on whether negatives are allowed.
    value = allowNegative ? value.replace(/[^0-9.-]/g, '') : value.replace(/[^0-9.]/g, '');

    if (allowNegative) {
      // Keep a minus sign only at the beginning.
      const isNegative = value.startsWith('-');
      value = value.replace(/-/g, '');

      if (isNegative) {
        value = '-' + value;
      }
    }

    // Allow only one decimal point.
    const isNegative = allowNegative && value.startsWith('-');
    let unsignedValue = isNegative ? value.substring(1) : value;

    const parts = unsignedValue.split('.');
    if (parts.length > 2) {
      unsignedValue = parts[0] + '.' + parts.slice(1).join('');
    }

    // Maximum 4 digits before the decimal.
    const valueParts = unsignedValue.split('.');
    valueParts[0] = valueParts[0].substring(0, 4);

    // Maximum 2 decimal places.
    if (valueParts.length > 1) {
      valueParts[1] = valueParts[1].substring(0, 2);
    }

    value = (isNegative ? '-' : '') + valueParts.join('.');

    // Maximum absolute amount: 9999.99.
    if (Math.abs(Number(value)) > 9999.99) {
      value = isNegative ? '-9999.99' : '9999.99';
    }

    // Update the actual input
    input.value = value;
    // IMPORTANT: Update ngModel data as well
    data[field] = value;
  }

  limitQuantity(event: Event, data: any, source: 'popup' | 'grid' = 'popup'): void {
    const input = event.target as HTMLInputElement;

    let value = input.value.replace(/\D/g, '').substring(0, 2);

    input.value = value;
    data.Quantity = value === '' ? null : Number(value);

    if (source === 'popup') {
      this.otherItemUpdate(data);
    }
  }

  setDefaultQuantity(event: Event, data: any): void {
    const input = event.target as HTMLInputElement;

    if (input.value === '' || Number(input.value) < 1) {
      input.value = '1';
      data.Quantity = 1;
    }

    if (data.isOtherItemChecked) {
      this.otherItemUpdate(data);
    }
  }

  ngOnDestroy(): void {
    if (this.tempRecordNo) {
      var temp = {
        TempRecordNo: this.tempRecordNo.toString(),
        BoothNo: ""
      }
      setTimeout(() => {
        this.subscriptions.push(
          this.operationRentalService.deleteFromTemp(temp).subscribe((res: any) => {
          })
        );
      }, 400);
    }

    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }
}
